/* hi-markt · Planer-App — Rahmen, Zustand und Bildschirmwechsel (Phase 2).

   Drei Bildschirme: Ihr Raum → Ihr Stil → Ihre Küche. Gerechnet wird hier nichts: jede Zahl,
   jede Regel und jede Kueche kommt aus dem Kern (hm-konfigurator.js, `K`). Diese Datei haelt
   den Zustand, entscheidet, welcher Bildschirm zu sehen ist, und schreibt ihn in den Speicher.

   DER SPEICHER IST DERSELBE WIE BEIM ALTEN PLANER (`hmk-planer-v2`, Schema 3). Wer auf einer
   Seite plant und die andere oeffnet, findet seine Kueche wieder. Die alte Seite kennt fuenf
   Schritte (1 Raum, 2 Anschluesse, 3 Serie, 4 Schraenke, 5 Angebot), die App drei
   Bildschirme; `schirmVonStep` und `stepVonSchirm` uebersetzen, und nur sie.

   Der ZURUECK-KNOPF DES TELEFONS fuehrt einen Bildschirm zurueck, nicht aus dem Planer hinaus:
   jeder Wechsel legt einen Eintrag in die Browser-Geschichte. Sonst verlaesst der Kunde auf
   Android mit einem Wisch die ganze Planung.

   Oben die reinen Regeln (ohne DOM, im Netz pruefbar), darunter die Bedienung. */
(function (w) {
  'use strict';

  var K = w.HMKonfig;

  var SCHIRME = [
    /* Namen wie im Markt (Betreiber 2026-09-26: „Oberfläche und Begriffe verständlich und marktüblich“). */
    { id: 'raum',        name: 'Raum & Maße',   step: 1, weiter: 'Weiter' },
    { id: 'ausstattung', name: 'Ausstattung',   step: 2, weiter: 'Weiter zur Serie' },
    { id: 'stil',        name: 'Serie & Farbe', step: 3, weiter: 'Küche ansehen' },
    { id: 'kueche',      name: 'Ihre Küche',  step: 4, weiter: 'Zur Kasse' }
  ];

  function schirmNr(id) {
    for (var i = 0; i < SCHIRME.length; i++) { if (SCHIRME[i].id === id) return i; }
    return -1;
  }

  /* Alter Schritt -> Bildschirm. Schritt 2 (Anschluesse) gehoert zum Raum, 5 (Angebot) zur
     Kueche. Ohne Serie gibt es keine Kueche — dann endet der Weg beim Stil. */
  function schirmVonStep(step, serie) {
    var s = +step || 1;
    if (s >= 4) return serie ? 'kueche' : 'stil';
    if (s === 3) return 'stil';
    if (s === 2) return 'ausstattung';
    return 'raum';
  }
  function stepVonSchirm(id) {
    var i = schirmNr(id);
    return (SCHIRME[i] || SCHIRME[0]).step;
  }

  function fehlerIn(meldungen) {
    return (meldungen || []).some(function (m) { return m.art === 'fehler'; });
  }

  /* Stufe 2 (2026-09-27): was die Raumpruefung des Kerns nicht kennt, eine Kueche aber unmoeglich macht — der
     Wasseranschluss in der Tuer, ein Fenster ueber der Tuer. Die Kasse prueft es nicht; der Raum sagt es sofort,
     bevor der Planer eine Kueche sucht, die es nicht gibt (Grosstest: keine Startkueche). */
  function bauKonflikte(z) {
    var mk = K && K.aktiveMerkmale ? K.aktiveMerkmale(z) : [], out = [];
    var tueren = mk.filter(function (m) { return m.typ === 'tuer'; });
    mk.forEach(function (m) {
      tueren.forEach(function (t) {
        if (m.wand !== t.wand || m === t) return;
        if ((m.typ === 'wasser' || m.typ === 'abfluss') && m.x > t.x - 5 && m.x < t.x + t.breite + 5) {
          out.push({ art: 'fehler', text: 'Der Wasseranschluss liegt in der Tür – bitte die Stelle prüfen.' });
        } else if (m.typ === 'fenster' && m.x < t.x + t.breite && t.x < m.x + m.breite) {
          out.push({ art: 'fehler', text: 'Fenster und Tür liegen übereinander – bitte die Stellen prüfen.' });
        }
      });
    });
    return out;
  }

  /* Darf der Kunde auf diesen Bildschirm? Der Stil braucht einen gueltigen Raum, die Kueche
     zusaetzlich eine geladene Serie mit Farbe. Die Pruefung ist die des Kerns. */
  function erreichbar(id, z, daten) {
    if (id === 'raum') return true;
    if (!K || fehlerIn(K.raumPruefung(z)) || fehlerIn(bauKonflikte(z))) return false;
    if (id === 'stil' || id === 'ausstattung') return true;
    if (id === 'kueche') return !!(z.serie && z.farbe && daten && daten.serie === z.serie);
    return false;
  }

  /* Der weiteste erreichbare Bildschirm bis `ziel` — fuer einen Sprung aus einem Lesezeichen
     oder der Geschichte, der inzwischen nicht mehr erlaubt ist. */
  function naechsterErlaubter(ziel, z, daten) {
    for (var i = Math.max(0, schirmNr(ziel)); i > 0; i--) {
      if (erreichbar(SCHIRME[i].id, z, daten)) return SCHIRME[i].id;
    }
    return 'raum';
  }

  w.HMPlanerApp = {
    SCHIRME: SCHIRME, schirmNr: schirmNr, schirmVonStep: schirmVonStep, stepVonSchirm: stepVonSchirm,
    erreichbar: erreichbar, naechsterErlaubter: naechsterErlaubter, bauKonflikte: bauKonflikte
  };

  /* ================= Bedienung ================= */

  var doc = w.document;
  var wurzel = doc && doc.querySelector('[data-hm-app]');
  if (!K || !wurzel) return;
  var CFG = w.hmPlanerApp || {};
  if (CFG.geld) K.setMoneyFormat(CFG.geld);

  var $ = function (sel) { return wurzel.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var esc = function (x) {
    return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* Derselbe Zustand wie auf der alten Seite — Feld fuer Feld, damit K.* und der Speicher ihn
     ohne Uebersetzung lesen. */
  var z = {
    step: 1, form: 'gerade', wand: 'A',
    A: 360, B: 240, C: 180, IL: 180, IT: 90, IG: 100,
    insel: false, inselDoppelt: false, bLinks: false, inselBasis: 'gerade', hoehe: 250,
    serie: null, farbe: '', zusatz: {},
    plan: {}, hoff: {}, xpos: {}, wahl: {},
    merkmale: [], mid: 1, sel: null, verloren: 0,
    zeigeOben: true, listeModus: true, zubehoer: {}, platte: null, ansicht: '2d', blick: 'perspektive',
    wunsch: {}
  };
  var daten = null, laedt = null, ladeFehler = null;
  var schirm = 'raum';
  var tiefe = 0;          /* wie viele Eintraege diese App selbst in die Geschichte gelegt hat */

  var g = K.gesichert();
  if (g) {
    ['form', 'wand', 'A', 'B', 'C', 'IL', 'IT', 'IG', 'insel', 'inselDoppelt', 'bLinks', 'inselBasis', 'hoehe',
     'serie', 'farbe', 'listeModus', 'zeigeOben', 'ansicht', 'blick', 'migrationStatus', 'legacyForm'].forEach(function (f) {
      if (g[f] != null) z[f] = g[f];
    });
    z.zusatz = g.zusatz || {};
    z.zubehoer = g.zubehoer || {};
    /* Die gewaehlte Arbeitsplatte (id) — ohne diese Zeile ginge sie beim naechsten Speichern verloren. */
    z.platte = g.platte || null;
    z.merkmale = g.merkmale || [];
    z.mid = g.mid || 1;
    /* Die Antworten der Ausstattung (Geschirrspueler, Backofen, Haengeschraenke, Arbeitsplatte). */
    z.wunsch = g.wunsch || {};
    schirm = schirmVonStep(g.step, g.serie);
  }

  /* Die Startkueche einmal je Planung — dieselbe Marke wie auf der alten Seite, damit ein
     Kunde, der dort die Wand geleert hat, sie hier nicht ungefragt wieder voll bekommt. */
  var START_MARKE = 'hmk-startkueche';
  function startMarke(wert) {
    try {
      if (wert === undefined) return w.localStorage.getItem(START_MARKE) === '1';
      if (wert) w.localStorage.setItem(START_MARKE, '1'); else w.localStorage.removeItem(START_MARKE);
    } catch (e) { /* ohne Speicher keine Marke */ }
    return false;
  }

  /* Nach „Neu beginnen" schreibt nichts mehr in den Speicher, bis die Seite neu geladen ist — ein
     Katalog, der gerade noch ankommt, legte sonst die geloeschte Planung wieder ab. */
  var verworfen = false;
  function merken() {
    if (verworfen) return;
    z.step = stepVonSchirm(schirm);
    K.sichern(z, daten);
  }

  /* ---------- Katalog ---------- */

  function serieLaden(name) {
    if (!name || laedt === name) return;
    laedt = name;
    ladeFehler = null;
    zeigen();
    K.laden(name, CFG.katalog).then(function (d) {
      if (verworfen) return;
      var alt = daten, r;
      if (alt) {
        r = K.umbau(z, alt, d);
      } else {
        var gs = K.gesichert();
        r = (gs && gs.serie === name) ? K.planIndizes(gs, d)
          : { plan: z.plan, hoff: z.hoff, xpos: z.xpos, wahl: z.wahl, verloren: 0 };
      }
      daten = d;
      laedt = null;
      z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl || {}; z.verloren = r.verloren;
      z.serie = d.serie;
      inselNormal();
      if (!d.farben || d.farben.indexOf(z.farbe) < 0) z.farbe = (d.farben || [])[0] || '';
      z.zusatz = K.zusatzUebernehmen(z.zusatz, d);
      z.zubehoer = K.zubehoerAufraeumen(z, d);
      /* Ein gespeicherter Stand „Kueche" wartete auf genau diesen Katalog. */
      if (wartetAuf) { var ziel = wartetAuf; wartetAuf = null; geheZu(ziel, 'ersetzen'); return; }
      merken();
      zeigen();
    }).catch(function () {
      laedt = null;
      ladeFehler = 'Der Schrankkatalog dieser Serie konnte nicht geladen werden. Bitte laden Sie die Seite neu.';
      if (wartetAuf) { wartetAuf = null; geheZu('stil', 'ersetzen'); return; }
      zeigen();
    });
  }
  var wartetAuf = null, neuGeplant = false;

  /* ---------- Bildschirmwechsel ---------- */

  /* art: 'push' (Kunde geht weiter), 'ersetzen' (Korrektur ohne neuen Eintrag), 'pop' (die
     Geschichte hat schon gewechselt). */
  function geheZu(id, art) {
    if (schirmNr(id) < 0) id = 'raum';
    if (!erreichbar(id, z, daten)) id = naechsterErlaubter(id, z, daten);
    var vorher = schirm;
    schirm = id;
    if (id !== 'kueche') rueckWeg();
    if (id !== 'kueche') { zusammenfassungSchliessen(); blattModus = z.sel ? 'auswahl' : 'ueberblick'; }
    if (id === 'kueche' && !K.anzahl(z, daten) && !startMarke()) {
      /* Eine Nische fuer den eigenen Geschirrspueler gehoert zur alten Kueche, nicht zum Raum: an
         ihrer alten Stelle stuende sie der neuen im Weg. Die WAHL bleibt (wunsch.gs) — die neue
         Kueche baut K.startKueche wieder mit Nische. */
      var nischen = stellplaetze();
      if (nischen.length) {
        z.merkmale = (z.merkmale || []).filter(function (m) { return nischen.indexOf(m) < 0; });
        z.wunsch = z.wunsch || {};
        if (!z.wunsch.gs && nischen.some(function (m) { return m.typ === 'spueler'; })) z.wunsch.gs = 'eigen';
        if (!z.wunsch.kuehl && nischen.some(function (m) { return m.typ === 'kuehl'; })) z.wunsch.kuehl = 'eigen';
      }
      z.wunsch = wunschFertig();
      var r = K.startKueche(z, daten);
      if (!r && nischen.length) z.merkmale = (z.merkmale || []).concat(nischen);
      if (r) {
        z.wand = r.wand; z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl; z.sel = null;
        if (r.merkmale) { z.merkmale = r.merkmale; z.mid = r.mid; }
        platteNachWunsch();
        startMarke(true);
        startPlanMerken();
        var vor = vorherLesen();
        if (vor && vor.serie === daten.serie) neuGeplant = true; else vorherSchreiben(null);
      }
    }
    try {
      if (art === 'push' && vorher !== id) { w.history.pushState({ hmApp: id }, '', '#' + id); tiefe++; }
      else if (art !== 'pop') w.history.replaceState({ hmApp: id }, '', '#' + id);
    } catch (e) { /* ohne Geschichte (z. B. in einem gesperrten Rahmen) geht es trotzdem weiter */ }
    merken();
    zeigen();
    /* Nach neuen Massen steht eine neue Kueche da. Wer seine alte (selbst geaenderte) zurueck will,
       bekommt denselben Rueckgaengig-Hinweis wie ueberall — einmal, und er verschwindet von selbst.
       Vorher war es eine feste Leiste mit eigenem Knopf und „×" (Betreiber: „ein seltsamer Knopf"). */
    if (id === 'kueche' && platteOffen && daten) { platteOffen = false; platteNachWunsch(); merken(); kuecheZeigen(); }
    if (neuGeplant) { neuGeplant = false; rueckZeigen('Neue Küche nach Ihren Angaben geplant.', vorherHolen, 10000); }
    /* Der Fokus wandert auf die Ueberschrift des neuen Bildschirms: ein Bildschirmleser haette
       sonst keinen Hinweis, dass der Inhalt gewechselt hat. Nicht beim ersten Aufbau. */
    if (vorher !== id && art !== 'start') {
      var h = $('[data-app-schirm="' + id + '"] .hm-app__h');
      if (h) h.focus({ preventScroll: true });
      var inhalt = $('[data-app-inhalt]');
      if (inhalt) inhalt.scrollTop = 0;
    }
  }

  /* Ohne Zustand kommt ein popstate, wenn nur der Anker der Adresse wechselt (#raum aus einem
     Link oder von Hand) — dann gilt der Anker. */
  w.addEventListener('popstate', function (e) {
    var id = (e.state && e.state.hmApp) || String(w.location.hash || '').replace('#', '');
    if (schirmNr(id) < 0) return;
    if (tiefe > 0) tiefe--;
    geheZu(id, 'pop');
  });

  /* ---------- Die Startkueche verwerfen, solange sie niemand angefasst hat ----------

     Wer Raum oder Stil aendert, nachdem die Kueche schon da war, will eine Kueche fuer den
     NEUEN Raum — nicht die alte, die jetzt 60 cm ueber die Wand ragt. Das gilt aber nur,
     solange der Kunde sie nicht selbst veraendert hat: seine eigenen Schraenke raeumt niemand
     ungefragt weg. „Unveraendert" heisst: die Fingerabdruecke stehen noch genau so da, wie die
     App sie gesetzt hat (eigener Speicherplatz, damit es ein Neuladen uebersteht). */
  var START_PLAN = 'hmk-app-startplan';
  function startPlanMerken() {
    try { w.localStorage.setItem(START_PLAN, JSON.stringify(K.planCodes(z, daten))); } catch (e) { /* ohne Speicher */ }
  }
  function istStartPlan() {
    if (!daten || !K.anzahl(z, daten)) return false;
    try { return w.localStorage.getItem(START_PLAN) === JSON.stringify(K.planCodes(z, daten)); } catch (e) { return false; }
  }
  function startVerwerfen() {
    if (!istStartPlan()) return;
    z.plan = {}; z.hoff = {}; z.xpos = {}; z.wahl = {}; z.sel = null;
    startMarke(false);
  }

  /* ---------- Neue Maße, neue Küche — mit Rückweg (Betreiber 2026-09-27) ----------

     Bisher baute der Planer die Küche nur EINMAL: war sie danach verändert, blieb sie bei neuen
     Maßen oder neuer Form stehen (sie passte dann nicht mehr), und eine geleerte Küche wurde nie
     wieder gefüllt. Der Betreiber: „warum wird keine Küche passend zu den Maßen geplant?".
     Entschieden: jede Änderung an Raum oder Form plant neu; die veränderte Küche wird vorher
     gesichert (samt ihrem Raum), und auf dem Küchen-Bildschirm steht „Vorherige Küche
     wiederherstellen". Gespeichert wie die Planung selbst (K.planNutzlast), damit der Rückweg
     ein Neuladen übersteht. Stil-Änderungen bleiben wie bisher (Umbau auf die neue Serie). */
  var VORHER = 'hmk-app-vorherige';
  var RAUM_FELDER = ['form', 'A', 'B', 'C', 'IL', 'IT', 'IG', 'insel', 'inselDoppelt', 'bLinks', 'inselBasis', 'hoehe', 'wand'];
  function vorherLesen() {
    try { return JSON.parse(w.localStorage.getItem(VORHER) || 'null'); } catch (e) { return null; }
  }
  function vorherSchreiben(v) {
    try { if (v) w.localStorage.setItem(VORHER, JSON.stringify(v)); else w.localStorage.removeItem(VORHER); }
    catch (e) { /* ohne Speicher kein Rückweg */ }
  }
  function raumNeu() {
    if (daten && K.anzahl(z, daten) && !istStartPlan()) vorherSchreiben(K.planNutzlast(z, daten));
    z.plan = {}; z.hoff = {}; z.xpos = {}; z.wahl = {}; z.sel = null;
    startMarke(false);
  }
  function vorherHolen() {
    var s = vorherLesen();
    if (!s || !daten || s.serie !== daten.serie) return;
    var r = K.planIndizes(s, daten);
    RAUM_FELDER.forEach(function (f) { if (s[f] !== undefined && s[f] !== null) z[f] = s[f]; });
    z.merkmale = s.merkmale || []; z.zubehoer = s.zubehoer || {}; z.platte = s.platte || null;
    z.wunsch = s.wunsch || z.wunsch || {};
    z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl || {}; z.sel = null;
    inselNormal();
    startMarke(true);
    vorherSchreiben(null);
    blattModus = 'ueberblick';
    merken();
    sagen('Vorherige Küche wiederhergestellt.');
    kuecheZeigen();
  }

  /* ---------- Bildschirm 1: Ihr Raum ---------- */

  var FORMEN = [
    { id: 'gerade', name: 'Küchen\u00ADzeile' }, { id: 'l', name: 'L-Form' },
    { id: 'u', name: 'U-Form' },
    /* Zwei gegenueberliegende Waende (Betreiber 2026-09-26). Der Kern kannte die Form schon, die App nicht. */
    { id: 'zweizeilig', name: 'Zwei\u00ADzeilig' },
    { id: 'insel', name: 'Küchen\u00ADinsel' }
  ];
  /* Draufsicht als kleines Bild: welche Wand ist gemeint? `hell` hebt eine Wand hervor. */
  function formBild(form, hell, links) {
    var L = function (d, an) { return '<path d="' + d + '" stroke-width="' + (an ? 5 : 3.2) + '" opacity="' + (hell && !an ? 0.3 : 1) + '"/>'; };
    var o = L('M6 7H34', hell === 'A'), r = L('M34 7V29', hell === 'B'), li = L('M6 7V29', hell === 'C' || (hell === 'B' && links));
    var teile = form === 'l' ? [o, links ? L('M6 7V29', hell === 'B') : r]
      : form === 'u' ? [o, r, li]
      /* Zwei Zeilen: oben die Hauptwand, unten die gegenueber; rechts gestrichelt der Abstand. */
      : form === 'zweizeilig' ? [o, L('M6 29H34', hell === 'C'),
          '<path d="M34 11V25" stroke-dasharray="2 3" stroke-width="' + (hell === 'B' ? 3 : 1.6) + '" opacity="' + (hell && hell !== 'B' ? 0.3 : 0.7) + '"/>']
      : form === 'insel' ? (z.inselBasis === 'l' ? [o, links ? L('M6 7V29', hell === 'B') : r]
          : z.inselBasis === 'u' ? [o, r, li] : [o])
          .concat(['<rect x="13" y="19" width="14" height="6" rx="1.5" stroke-width="' + (hell === 'IL' ? 3 : 2.2) + '" opacity="' + (hell && hell !== 'IL' ? 0.3 : 1) + '"/>'])
      : [o];
    return '<svg viewBox="0 0 40 34" fill="none" stroke="currentColor" stroke-linecap="round" aria-hidden="true">' + teile.join('') + '</svg>';
  }
  function wandFelder() {
    if (z.form === 'l') return [{ k: 'A', t: 'Hauptwand' }, { k: 'B', t: 'Seitenwand' }];
    if (z.form === 'u') return [{ k: 'A', t: 'Hauptwand' }, { k: 'B', t: 'Rechte Wand' }, { k: 'C', t: 'Linke Wand' }];
    if (z.form === 'insel' && z.inselBasis === 'l') return [{ k: 'A', t: 'Hauptwand' }, { k: 'B', t: 'Seitenwand' }, { k: 'IL', t: 'Insel' }];
    if (z.form === 'insel' && z.inselBasis === 'u') return [{ k: 'A', t: 'Hauptwand' }, { k: 'B', t: 'Rechte Wand' }, { k: 'C', t: 'Linke Wand' }, { k: 'IL', t: 'Insel' }];
    if (z.form === 'insel') return [{ k: 'A', t: 'Wand' }, { k: 'IL', t: 'Insel' }];
    if (z.form === 'zweizeilig') return [{ k: 'A', t: 'Hauptwand' }, { k: 'C', t: 'Gegenüberliegende Wand' }, { k: 'B', t: 'Abstand der Wände' }];
    return [{ k: 'A', t: 'Wandlänge' }];
  }
  var MASS_MIN = 60, MASS_MAX = 900, REGLER_MIN = 120, REGLER_MAX = 600;
  var klemme = function (v, a, b) { return Math.max(a, Math.min(b, Math.round(+v || 0))); };

  function raumFehler() {
    return K.raumPruefung(z).concat(bauKonflikte(z)).filter(function (m) { return m.art === 'fehler'; });
  }
  function raumZeileZeigen() {
    var f = raumFehler(), el = $('[data-app-raumfehler]');
    if (el) { el.hidden = !f.length; el.textContent = f.length ? f[0].text : ''; }
  }
  /* Zwei Zeilen in der Fussleiste: auf 320 px ist neben „Weiter zum Stil" nur 126 px Platz. */
  function raumText() {
    return [(z.form === 'insel' ? ({ l: 'L-Küche', u: 'U-Küche' }[z.inselBasis] || 'Küchenzeile') + (z.inselDoppelt && doppelSteht() ? ' mit Doppelinsel' : ' mit Insel')
      : { gerade: 'Küchenzeile', l: 'L-Küche', u: 'U-Küche', zweizeilig: 'Zweizeilige Küche' }[z.form]) || 'Küche',
      wandFelder().map(function (f) { return z[f.k]; }).join(' · ') + ' cm'];
  }

  /* Doppelinsel (Betreiber 2026-09-27): Schraenke auf beiden Seiten der Insel, Ruecken an
     Ruecken. Ist der Raum dafuer zu flach, bleibt die Insel einseitig, und das steht hier —
     nicht erst in der Kueche. */
  function inselSeitenFeld() {
    if (z.form !== 'insel') return '';
    return '<div class="hm-app__ecke hm-app__ecke--voll" role="group" aria-label="Schränke an der Insel"><span>Schränke an der Insel</span>'
      + [['0', 'Eine Seite'], ['1', 'Beide Seiten']].map(function (o) {
        return '<button type="button" class="hm-app__chip" data-doppelt="' + o[0] + '" aria-pressed="' + ((o[0] === '1') === !!z.inselDoppelt) + '">' + o[1] + '</button>';
      }).join('') + '</div><p class="hm-app__klein" data-app-doppelhinweis role="status"' + (z.inselDoppelt ? '' : ' hidden') + '>' + doppelHinweisText() + '</p>';
  }
  function doppelZuFlach() {
    var b = (K.raumGeometrie(z).bloecke || [])[0];
    return !!z.inselDoppelt && !!b && b.doppeltPasst === false;
  }
  function doppelSteht() { return K.raumGeometrie(z).bloecke.some(function (b) { return b.id === 'IH'; }); }
  function doppelHinweisText() {
    var b = (K.raumGeometrie(z).bloecke || [])[0];
    return doppelZuFlach()
      ? 'Für Schränke auf beiden Seiten braucht der Raum ' + b.doppeltBraucht + ' cm Tiefe'
        + (z.inselBasis === 'u' ? ' (Seitenwände)' : ' (Seitenwand)') + ' — bis dahin bleibt die Insel einseitig.'
      : 'Schränke auf beiden Seiten, Rücken an Rücken — zur Küche hin und zum Raum hin. Die Arbeitsplatte der Insel ist nicht im Preis enthalten.';
  }
  /* Die Masse aendern sich unter dem Finger (Regler, ±) ohne Neuaufbau — der Hinweis zieht mit. */
  /* Zweizeilig: der Durchgang zwischen den Zeilen, von Plattenkante zu Plattenkante — so, wie ihn die
     Raumpruefung des Kerns misst (unter 60 cm Fehler, unter 100 cm Hinweis). */
  function gangText() {
    var gang = Math.round(+z.B - 2 * K.platteTiefe());
    if (gang < 60) return 'Durchgang zwischen den Zeilen: ' + Math.max(0, gang) + ' cm — zu schmal.';
    if (gang < 100) return 'Durchgang zwischen den Zeilen: ' + gang + ' cm — eng; bequem sind 100 cm, für zwei Personen 120 cm.';
    return 'Durchgang zwischen den Zeilen: ' + gang + ' cm.';
  }
  function gangHinweisZeigen() {
    var p = $('[data-app-ganghinweis]');
    if (!p) return;
    p.textContent = gangText();
    p.classList.toggle('hm-app__fehler', Math.round(+z.B - 2 * K.platteTiefe()) < 100);
  }
  function doppelHinweisZeigen() {
    var p = $('[data-app-doppelhinweis]');
    if (!p) return;
    p.hidden = !z.inselDoppelt;
    p.textContent = doppelHinweisText();
    p.classList.toggle('hm-app__fehler', doppelZuFlach());
  }

  /* ---------- Fenster, Tür und Wasseranschluss (Stufe 2, 2026-09-27) ----------

     Der Kern kennt Fenster, Tür und Wasser seit dem alten Planer (Merkmale); die App fragte sie nicht ab, und
     die Startküche stellte das Kochfeld, wohin es fiel (ROYAL24: unter das Fenster). Jetzt fragt der Raum: an
     welcher Wand, wie weit von links, wie breit — beim Fenster auch die Brüstungshöhe. K.startKueche setzt die
     Spüle über den Wasseranschluss bzw. unter das Fenster, das Kochfeld nie darunter, und vor Fenster und Tür
     steht nichts. Je Art EIN Eintrag; was der alte Planer sonst kennt (Heizkörper, Steckdosen …), bleibt
     unberührt. Jede Änderung plant die Küche neu, mit Rückweg zur vorigen — wie neue Maße. */
  var BAU = [
    { typ: 'fenster', t: 'Fenster', nein: 'Nein', felder: ['x', 'breite', 'hoehe'],
      hilfe: 'Abstand von der linken Wandecke bis zum Fenster. Brüstungshöhe: vom Boden bis zur Fensterbank.' },
    { typ: 'tuer', t: 'Tür', nein: 'Nein', felder: ['x', 'breite'],
      hilfe: 'Abstand von der linken Wandecke bis zur Tür, Breite mit Türrahmen.' },
    { typ: 'wasser', t: 'Wasseranschluss', nein: 'Weiß nicht', felder: ['x'],
      hilfe: 'Abstand von der linken Wandecke bis zur Mitte des Anschlusses.' }
  ];
  var BAU_FELD = { x: 'Abstand von links', breite: 'Breite', hoehe: 'Brüstungshöhe' };
  /* Nur die Wände, an denen Schränke stehen — die Insel ist keine Wand, der Durchgang der Zweizeiligen trägt keine. */
  function bauWaende() {
    return K.raumGeometrie(z).waende.filter(function (w) { return w.planbar !== false; }).map(function (w) { return w.id; });
  }
  function bauWandName(id) {
    var f = wandFelder().filter(function (x) { return x.k === id; })[0];
    return f && id !== 'A' ? f.t : (bauWaende().length > 1 ? 'Hauptwand' : 'Küchenwand');
  }
  /* Der Eintrag dieser Art an einer Wand der jetzigen Form; beim Wasser zählt auch ein Abfluss aus dem alten Planer. */
  function bauEintrag(typ) {
    var ak = K.aktiveMerkmale(z).filter(function (m) { return bauWaende().indexOf(m.wand) > -1; });
    return ak.filter(function (m) { return m.typ === typ; })[0]
      || (typ === 'wasser' ? ak.filter(function (m) { return m.typ === 'abfluss'; })[0] : null) || null;
  }
  function bauMax(m) {
    var len = K.wandObj(z, m.wand).len;
    return Math.max(0, Math.round(len - (K.MT[m.typ].breite ? (+m.breite || 0) : 0)));
  }
  /* Die Tür steht ab Werk am Ende ohne Ecke: dort liegt sie in einer echten Küche meist, und die Küche bleibt ganz. */
  function bauStart(typ, wand) {
    var len = K.wandObj(z, wand).len, raum = K.raumGeometrie(z);
    var m = { id: 0, typ: typ, wand: wand, breite: 0, hoehe: K.MT[typ].hoehe || 0 };
    if (typ === 'fenster') { m.breite = Math.min(100, Math.max(40, len - 20)); m.hoehe = 100; m.x = Math.round((len - m.breite) / 2); }
    else if (typ === 'tuer') {
      m.breite = Math.min(88, len);
      var eckeEnde = !!K.schrankEckeAn(raum, wand, 'ende') && !K.schrankEckeAn(raum, wand, 'anfang');
      m.x = eckeEnde ? Math.min(10, len - m.breite) : Math.max(0, Math.round(len - m.breite - 10));
    } else {
      var f = K.aktiveMerkmale(z).filter(function (x) { return x.typ === 'fenster' && x.wand === wand; })[0];
      m.x = f ? Math.round(f.x + f.breite / 2) : Math.round(len / 2);
    }
    return m;
  }
  function bauWandSetzen(typ, wand) {
    var alt = bauEintrag(typ);
    if ((alt ? alt.wand : '') === wand) return;
    raumNeu();
    /* „Nein" / „Weiß nicht" nimmt jeden Eintrag dieser Art weg — auch einen, der an einer Wand einer anderen Form ruht. */
    var weg = typ === 'wasser' ? /^(wasser|abfluss)$/ : new RegExp('^' + typ + '$');
    var rest = (z.merkmale || []).filter(function (m) { return !weg.test(m.typ) || (alt && m.id === alt.id); });
    if (!wand) {
      z.merkmale = rest.filter(function (m) { return !weg.test(m.typ); });
    } else {
      var neu = bauStart(typ, wand);
      if (alt) { neu.breite = alt.breite || neu.breite; neu.hoehe = alt.hoehe || neu.hoehe; if (typ !== 'wasser') neu.x = Math.min(neu.x, Math.max(0, Math.round(K.wandObj(z, wand).len - neu.breite))); }
      neu.id = alt ? alt.id : Math.max(+z.mid || 1, 1 + (z.merkmale || []).reduce(function (a, x) { return Math.max(a, +x.id || 0); }, 0));
      if (!alt) z.mid = neu.id + 1;
      if (alt) neu.typ = alt.typ;
      z.merkmale = rest.filter(function (m) { return !(alt && m.id === alt.id); }).concat([neu]);
    }
    merken(); zeigen();
  }
  /* Ein Maß ändern, ohne den Bildschirm neu zu bauen: der Regler bleibt unter dem Finger. */
  function bauFeldSetzen(typ, feld, wert, quelle, box) {
    var m = bauEintrag(typ);
    if (!m) return;
    var len = K.wandObj(z, m.wand).len;
    var grenzen = { x: [0, bauMax(m)], breite: [typ === 'tuer' ? 60 : 40, Math.round(len)], hoehe: [0, 180] }[feld];
    var v = klemme(wert, grenzen[0], grenzen[1]);
    if (v === +m[feld]) return;
    raumNeu();
    var neu = K.merkmalSetzen(z, m, feld, v);
    z.merkmale = (z.merkmale || []).map(function (x) { return x === m ? neu : x; });
    var zahl = box.querySelector('[data-bauzahl="' + typ + ':' + feld + '"]'), regler = box.querySelector('[data-bauregler="' + typ + ':' + feld + '"]');
    if (zahl && quelle !== 'zahl') zahl.value = v;
    if (regler && quelle !== 'regler') regler.value = v;
    /* Die Breite verschiebt das Ende des Schiebewegs. */
    if (feld === 'breite') {
      var rx = box.querySelector('[data-bauregler="' + typ + ':x"]');
      if (rx) rx.max = bauMax(neu);
    }
    bauSkizzenZeigen(box);
    raumZeileZeigen();
    grundrissZeigen();
    fussZeigen();
  }
  var BAU_BILD = {
    fenster: '<svg viewBox="0 0 32 28" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="7" y="4" width="18" height="16" rx="1"/><path d="M16 4v16M7 12h18M4 23h24"/></svg>',
    tuer: '<svg viewBox="0 0 32 28" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 26V3h14v23M5 26h22"/><circle cx="19.5" cy="15" r="1.3" fill="currentColor"/></svg>',
    wasser: '<svg viewBox="0 0 32 28" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M16 4c4 5 7 9 7 13a7 7 0 0 1-14 0c0-4 3-8 7-13z"/></svg>'
  };
  /* Eine kleine Frontansicht je Wand mit Eintrag: wo Fenster, Tür und Wasser liegen, ob die Fensterbank über der
     Arbeitsplatte liegt. Nur zur Orientierung — die Eingabe sind die Felder darüber. */
  function bauSkizze(wand) {
    var mk = K.aktiveMerkmale(z).filter(function (m) { return m.wand === wand && /^(fenster|tuer|wasser|abfluss)$/.test(m.typ); });
    if (!mk.length) return '';
    var len = Math.round(K.wandObj(z, wand).len), RH = +z.hoehe || 250, y = function (h) { return RH - h; };
    /* Die Beschriftung der Arbeitsplatte dorthin, wo sie nichts verdeckt: links oder rechts, ueber oder unter der Linie. */
    var kasten = mk.map(function (m) {
      if (m.typ === 'fenster') { var f0 = K.fensterOeffnung(m, RH); return [m.x, f0.unten, m.x + m.breite, f0.oben]; }
      if (m.typ === 'tuer') return [m.x, 0, m.x + m.breite, m.hoehe];
      return [m.x - 45, 30, m.x + 45, 100];
    });
    var lage = [[6, 97, 0], [len - 6, 97, 1], [6, 66, 0], [len - 6, 66, 1]].filter(function (l) {
      var a0 = l[2] ? l[0] - 140 : l[0], a1 = a0 + 140;
      return !kasten.some(function (k) { return a0 < k[2] && k[0] < a1 && l[1] < k[3] && k[1] < l[1] + 20; });
    })[0];
    var o = ['<rect class="hm-sk__wand" x="0" y="0" width="' + len + '" height="' + RH + '"/>',
      '<line class="hm-sk__platte" x1="0" x2="' + len + '" y1="' + y(90) + '" y2="' + y(90) + '"/>'];
    if (lage) o.push('<text class="hm-sk__ap" x="' + lage[0] + '" y="' + y(lage[1]) + '"' + (lage[2] ? ' text-anchor="end"' : '') + '>Arbeitsplatte</text>');
    mk.forEach(function (m) {
      if (m.typ === 'fenster') {
        var f = K.fensterOeffnung(m, RH);
        o.push('<rect class="hm-sk__fenster" x="' + m.x + '" y="' + y(f.oben) + '" width="' + m.breite + '" height="' + f.h + '"/>'
          + '<text class="hm-sk__txt" x="' + (m.x + m.breite / 2) + '" y="' + (y(f.oben) + f.h / 2 + 7) + '">Fenster</text>');
      } else if (m.typ === 'tuer') {
        o.push('<rect class="hm-sk__tuer" x="' + m.x + '" y="' + y(m.hoehe) + '" width="' + m.breite + '" height="' + m.hoehe + '"/>'
          + '<text class="hm-sk__txt" x="' + (m.x + m.breite / 2) + '" y="' + y(m.hoehe / 2) + '">Tür</text>');
      } else {
        /* Die Beschriftung neben den Punkt, nicht darueber: dort liegt die Linie der Arbeitsplatte (90 cm). */
        var rechtsFrei = m.x < len - 110;
        o.push('<line class="hm-sk__wlinie" x1="' + m.x + '" x2="' + m.x + '" y1="' + y(55) + '" y2="' + RH + '"/>'
          + '<circle class="hm-sk__wasser" cx="' + m.x + '" cy="' + y(55) + '" r="9"/>'
          + '<text class="hm-sk__txt" x="' + (rechtsFrei ? m.x + 16 : m.x - 16) + '" y="' + (y(55) + 8) + '" style="text-anchor:' + (rechtsFrei ? 'start' : 'end') + '">Wasser</text>');
      }
    });
    return '<figure class="hm-app__skizze"><svg viewBox="-3 -3 ' + (len + 6) + ' ' + (RH + 6) + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true">'
      + o.join('') + '</svg><figcaption>' + esc(bauWandName(wand)) + ' · ' + len + ' cm</figcaption></figure>';
  }
  function bauSkizzenZeigen(box) {
    var ort = box.querySelector('[data-app-skizzen]');
    if (ort) ort.innerHTML = bauWaende().map(bauSkizze).join('');
  }
  function bauHtml() {
    var waende = bauWaende();
    return '<div class="hm-app__bau"><p class="hm-app__lab" id="hm-app-bau">Fenster, Tür und Wasser</p>'
      + '<p class="hm-app__klein hm-app__bautext">Damit die Spüle unter das Fenster kommt und nichts vor Fenster oder Tür steht.</p>'
      + BAU.map(function (q) {
        var m = bauEintrag(q.typ), jetzt = m ? m.wand : '';
        var chips = [['', q.nein]].concat(waende.map(function (id) { return [id, waende.length > 1 ? bauWandName(id) : 'Ja']; }));
        return '<div class="hm-app__baufrage" role="group" aria-labelledby="hm-bau-' + q.typ + '">'
          + '<div class="hm-app__baukopf"><b id="hm-bau-' + q.typ + '">' + BAU_BILD[q.typ] + '<span>' + q.t + '</span></b>'
          + '<div class="hm-app__chips">' + chips.map(function (c) {
            return '<button type="button" class="hm-app__chip" data-bauwand="' + q.typ + ':' + c[0] + '" aria-pressed="' + (c[0] === jetzt) + '">' + esc(c[1]) + '</button>';
          }).join('') + '</div></div>'
          + (m ? '<div class="hm-app__baumasse">' + q.felder.map(function (fd) {
            var id = 'hm-bau-' + q.typ + '-' + fd, v = Math.round(+m[fd] || 0);
            if (fd === 'x') {
              return '<div class="hm-app__baux"><div class="hm-app__baurz"><label for="' + id + '">' + BAU_FELD.x + '</label>'
                + '<span class="hm-app__zahl hm-app__zahl--klein"><input id="' + id + '" type="number" inputmode="numeric" min="0" max="' + bauMax(m) + '" step="1" value="' + v + '" data-bauzahl="' + q.typ + ':x"><em>cm</em></span></div>'
                + '<div class="hm-app__wandregler">'
                + '<button type="button" class="hm-app__pm" data-baupm="' + q.typ + ':-1" aria-label="' + q.t + ' 1 cm weiter links">−</button>'
                + '<input class="hm-app__regler" type="range" min="0" max="' + bauMax(m) + '" step="1" value="' + v + '" data-bauregler="' + q.typ + ':x" aria-label="' + q.t + ': Abstand von links in Zentimetern">'
                + '<button type="button" class="hm-app__pm" data-baupm="' + q.typ + ':1" aria-label="' + q.t + ' 1 cm weiter rechts">+</button></div></div>';
            }
            return '<div class="hm-app__baurz"><label for="' + id + '">' + BAU_FELD[fd] + '</label>'
              + '<span class="hm-app__zahl hm-app__zahl--klein"><input id="' + id + '" type="number" inputmode="numeric" step="1" value="' + v + '" data-bauzahl="' + q.typ + ':' + fd + '"><em>cm</em></span></div>';
          }).join('') + '<p class="hm-app__klein">' + esc(q.hilfe) + '</p></div>' : '')
          + '</div>';
      }).join('')
      + '<div class="hm-app__skizzen" data-app-skizzen></div></div>';
  }
  function bauBinden(box) {
    box.querySelectorAll('[data-bauwand]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-bauwand').split(':');
        bauWandSetzen(t[0], t[1]);
      });
    });
    box.querySelectorAll('[data-bauregler]').forEach(function (r) {
      var t = r.getAttribute('data-bauregler').split(':');
      r.addEventListener('input', function () { bauFeldSetzen(t[0], t[1], r.value, 'regler', box); });
      r.addEventListener('change', merken);
    });
    box.querySelectorAll('[data-bauzahl]').forEach(function (inp) {
      var t = inp.getAttribute('data-bauzahl').split(':');
      inp.addEventListener('change', function () {
        bauFeldSetzen(t[0], t[1], inp.value, 'zahl', box);
        var m = bauEintrag(t[0]); if (m) inp.value = Math.round(+m[t[1]] || 0);
        merken();
      });
    });
    box.querySelectorAll('[data-baupm]').forEach(function (b) {
      var t = b.getAttribute('data-baupm').split(':');
      b.addEventListener('click', function () {
        var m = bauEintrag(t[0]);
        if (!m) return;
        bauFeldSetzen(t[0], 'x', Math.round(+m.x) + (+t[1]), 'pm', box);
        merken();
      });
    });
    bauSkizzenZeigen(box);
  }

  function raumZeigen() {
    var box = $('[data-app-raum]');
    var links = !!z.bLinks;
    box.innerHTML = '<div class="hm-app__raumlayout"><div class="hm-app__raumspalte">'
      + '<div class="hm-app__formen" role="group" aria-label="Küchenform">'
      + FORMEN.map(function (f) {
        return '<button type="button" class="hm-app__form" data-form="' + f.id + '" aria-pressed="' + (z.form === f.id) + '">'
          + formBild(f.id, null, f.id === 'l' && links) + '<span' + (f.name.indexOf('\u00AD') > -1 ? ' data-weich' : '') + '>' + f.name + '</span></button>';
      }).join('') + '</div>'
      /* Die Insel steht vor einer Grundform — Zeile, L oder U (Betreiber: „die Insel laesst sich
         nicht aendern"; bisher gab es sie nur vor der Zeile, und ein Formwechsel nahm sie weg). */
      + (z.form === 'insel' ? '<div class="hm-app__ecke hm-app__ecke--voll" role="group" aria-label="Grundform vor der Insel"><span>Form an der Wand</span>'
        + [['gerade', 'Küchenzeile'], ['l', 'L-Form'], ['u', 'U-Form']].map(function (b) {
          return '<button type="button" class="hm-app__chip" data-basis="' + b[0] + '" aria-pressed="' + ((z.inselBasis || 'gerade') === b[0]) + '">' + b[1] + '</button>';
        }).join('') + '</div>' : '')
      + inselSeitenFeld()
      + (z.form === 'l' || (z.form === 'insel' && z.inselBasis === 'l') ? '<div class="hm-app__ecke" role="group" aria-label="Seite der Ecke"><span>Ecke</span>'
        + '<button type="button" class="hm-app__chip" data-ecke="links" aria-pressed="' + links + '">links</button>'
        + '<button type="button" class="hm-app__chip" data-ecke="rechts" aria-pressed="' + !links + '">rechts</button></div>' : '')
      + wandFelder().map(function (f) {
        var id = 'hm-app-m' + f.k;
        return '<div class="hm-app__wand" data-wand="' + f.k + '">'
          + '<div class="hm-app__wandkopf">' + formBild(z.form, f.k, links)
          + '<label for="' + id + '">' + f.t + '</label>'
          + '<span class="hm-app__zahl"><input id="' + id + '" type="number" inputmode="numeric" min="' + MASS_MIN + '" max="' + MASS_MAX + '" step="1" value="' + esc(z[f.k]) + '" data-zahl="' + f.k + '"><em>cm</em></span></div>'
          + '<div class="hm-app__wandregler">'
          + '<button type="button" class="hm-app__pm" data-pm="-1" data-k="' + f.k + '" aria-label="' + f.t + ' 1 cm kürzer">−</button>'
          + '<input class="hm-app__regler" type="range" min="' + REGLER_MIN + '" max="' + REGLER_MAX + '" step="10" value="' + klemme(z[f.k], REGLER_MIN, REGLER_MAX) + '" data-regler="' + f.k + '" aria-label="' + f.t + ' in Zentimetern">'
          + '<button type="button" class="hm-app__pm" data-pm="1" data-k="' + f.k + '" aria-label="' + f.t + ' 1 cm länger">+</button></div>'
          + '</div>';
      }).join('')
      + (z.form === 'zweizeilig' ? '<p class="hm-app__klein" data-app-ganghinweis role="status">' + esc(gangText()) + '</p>' : '')
      + bauHtml()
      + '<details class="hm-app__mehr"' + (z.hoehe !== 250 ? ' open' : '') + '><summary>Raumhöhe &amp; weitere Maße</summary>'
      + '<div class="hm-app__mehrin"><label for="hm-app-mhoehe">Raumhöhe</label>'
      + '<span class="hm-app__zahl hm-app__zahl--klein"><input id="hm-app-mhoehe" type="number" inputmode="numeric" min="200" max="350" step="1" value="' + esc(z.hoehe) + '" data-zahl="hoehe"><em>cm</em></span></div>'
      + '<p class="hm-app__klein">Nur wichtig, wenn Sie Hochschränke planen.</p></details>'
      + '<p class="hm-app__hinweis hm-app__fehler" data-app-raumfehler role="alert" hidden></p>'
      + '</div><div class="hm-app__grundriss" data-app-grundriss aria-hidden="true"></div></div>';

    box.querySelectorAll('[data-form]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-form');
        if (f === z.form) return;
        raumNeu();
        /* Die Insel ist hier eine eigene Form (Zeile + Insel). Eine Insel aus dem alten Planer an
           einer L- oder U-Kueche faellt beim Formwechsel weg, sie kehrt nicht still zurueck. */
        /* Von L oder U zur Insel: die Grundform bleibt, die Insel kommt dazu. */
        z.inselBasis = f === 'insel' && (z.form === 'l' || z.form === 'u') ? z.form : 'gerade';
        /* Zwei Zeilen sind meist gleich lang: die Gegenueber-Wand beginnt so lang wie die Hauptwand
           (vorher stand dort die Linke Wand der U-Kueche, 180 cm). Aendern kann der Kunde sie sofort. */
        if (f === 'zweizeilig' && +z.C < +z.A) z.C = z.A;
        z.form = f; z.insel = false;
        z.wand = 'A';
        merken(); zeigen();
      });
    });
    box.querySelectorAll('[data-basis]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-basis');
        if (v === (z.inselBasis || 'gerade')) return;
        raumNeu();
        z.inselBasis = v; z.wand = 'A';
        merken(); zeigen();
      });
    });
    box.querySelectorAll('[data-doppelt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-doppelt') === '1';
        if (v === !!z.inselDoppelt) return;
        raumNeu();
        z.inselDoppelt = v;
        if (!v && z.wand === 'IH') z.wand = 'I';
        merken(); zeigen();
      });
    });
    box.querySelectorAll('[data-ecke]').forEach(function (b) {
      b.addEventListener('click', function () {
        raumNeu();
        z.bLinks = b.getAttribute('data-ecke') === 'links';
        merken(); zeigen();
      });
    });
    var setze = function (k, v, quelle) {
      var min = k === 'hoehe' ? 200 : MASS_MIN, max = k === 'hoehe' ? 350 : MASS_MAX;
      v = klemme(v, min, max);
      if (v === z[k]) return;
      /* Die Raumhoehe aendert keine Wand — die Kueche bleibt; alle anderen Masse planen neu. */
      if (k === 'hoehe') startVerwerfen(); else raumNeu();
      z[k] = v;
      var zahl = box.querySelector('[data-zahl="' + k + '"]'), regler = box.querySelector('[data-regler="' + k + '"]');
      if (zahl && quelle !== 'zahl') zahl.value = v;
      if (regler && quelle !== 'regler') regler.value = klemme(v, REGLER_MIN, REGLER_MAX);
      raumZeileZeigen();
      grundrissZeigen();
      doppelHinweisZeigen();
      gangHinweisZeigen();
      /* Eine laengere oder kuerzere Wand verschiebt das Ende des Schiebewegs von Fenster, Tuer und Wasser. */
      BAU.forEach(function (q) {
        var m = bauEintrag(q.typ), rx = box.querySelector('[data-bauregler="' + q.typ + ':x"]');
        if (m && rx) rx.max = bauMax(m);
      });
      bauSkizzenZeigen(box);
      fussZeigen();
    };
    /* Der Regler schreibt waehrend des Ziehens nur Zahl und Pruefzeile — kein Neuaufbau, sonst
       risse jede Bewegung den Regler unter dem Finger weg. Gespeichert wird beim Loslassen. */
    box.querySelectorAll('[data-regler]').forEach(function (r) {
      r.addEventListener('input', function () { setze(r.getAttribute('data-regler'), r.value, 'regler'); });
      r.addEventListener('change', merken);
    });
    box.querySelectorAll('[data-zahl]').forEach(function (inp) {
      inp.addEventListener('change', function () { setze(inp.getAttribute('data-zahl'), inp.value, 'zahl'); inp.value = z[inp.getAttribute('data-zahl')]; merken(); });
    });
    box.querySelectorAll('[data-pm]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-k');
        setze(k, z[k] + (+b.getAttribute('data-pm')));
        merken();
      });
    });
    bauBinden(box);
    raumZeileZeigen();
    grundrissZeigen();
    doppelHinweisZeigen();
  }

  /* Auf breiten Bildschirmen steht neben den Massen der Grundriss aus dem Kern — derselbe wie
     im alten Planer, nur ohne Bedienung. Auf dem Telefon ist er ausgeblendet (dort fehlt der
     Platz, PLAN §3) und wird dann auch nicht gerechnet. Die Schrift rechnet der Kern aus dem
     Massstab, mit dem `meet` wirklich zeichnet — zweimal, wie bei der Frontansicht. */
  function grundrissZeigen() {
    var box = $('[data-app-grundriss]');
    if (!box || !box.offsetParent || fehlerIn(K.raumPruefung(z))) { if (box) box.innerHTML = ''; return; }
    var bw = box.clientWidth, bh = box.clientHeight;
    var k = 1, p = K.planZeichnung(z, daten && daten.serie === z.serie ? daten : null, k, false);
    for (var n = 0; n < 2; n++) {
      var vb = String(p.vb).split(/\s+/).map(Number);
      if (!(vb[2] > 0 && vb[3] > 0 && bw > 0 && bh > 0)) break;
      var neuK = Math.min(bw / vb[2], bh / vb[3]);
      if (Math.abs(neuK - k) / k < 0.05) break;
      k = neuK;
      p = K.planZeichnung(z, daten && daten.serie === z.serie ? daten : null, k, false);
    }
    box.innerHTML = '<svg viewBox="' + p.vb + '" preserveAspectRatio="xMidYMid meet">' + p.inner + '</svg>';
    /* „WAND A" → derselbe Wandname wie in Bildschirm 3 (PLAN §3). Die Kennung einer Wand steht
       im Kern als Grossschrift; ersetzt wird genau dieser Text, sonst nichts. */
    var namen = {};
    ['A', 'B', 'C'].forEach(function (id) { namen['WAND ' + id] = wandName(id).toUpperCase(); });
    Array.prototype.forEach.call(box.querySelectorAll('svg text'), function (t) {
      var n = namen[t.textContent.trim()];
      if (n) t.textContent = n;
    });
  }

  /* ---------- Bildschirm 2: Ihr Stil ---------- */

  /* Alle vier Kataloge — die Karten zeigen fuer JEDE Serie einen Preis. Geladen wird, sobald
     der Raum steht (nicht erst beim Tippen auf „Weiter"); jeder ist einmal im Speicher des Kerns. */
  var kataloge = {};
  function alleLaden() {
    K.SERIEN.forEach(function (s) {
      if (kataloge[s.name]) return;
      K.laden(s.name, CFG.katalog).then(function (d) {
        kataloge[s.name] = d;
        if (schirm === 'stil') preiseRechnen();
      }).catch(function () { /* die Karte zeigt dann keinen Preis */ });
    });
  }

  /* „ab X €" = die Startkueche fuer GENAU diesen Raum, in der guenstigsten Farbe. Gerechnet vom
     Kern, wie jede Zahl dieser App. Eine Farbe kostet 5–30 ms; alle 20 auf einmal liessen ein
     Mittelklassetelefon eine halbe Sekunde stehen — deshalb Farbe fuer Farbe, dazwischen darf
     der Browser zeichnen. */
  var preise = {}, rechnet = false;
  function raumSchluessel(serie, farbe, zusatz) {
    /* Die Antworten der Ausstattung gehoeren dazu: mit Kuehlschrank ist dieselbe Kueche eine andere. */
    return JSON.stringify([z.form, z.A, z.B, z.C, z.IL, z.IT, z.IG, !!z.bLinks, z.inselBasis || 'gerade', !!z.inselDoppelt, z.hoehe, serie, farbe, zusatz || {}, z.merkmale || [], wunschFertig()]);
  }
  function stilZusatz(d) {
    return K.zusatzUebernehmen(z.serie === d.serie ? z.zusatz : {}, d);
  }
  function preisVon(d, farbe) {
    var zus = stilZusatz(d), k = raumSchluessel(d.serie, farbe, zus);
    if (!(k in preise)) return undefined;
    return preise[k];
  }
  function preiseRechnen() {
    if (rechnet) return;
    var offen = [];
    K.SERIEN.forEach(function (s) {
      var d = kataloge[s.name];
      if (!d) return;
      (d.farben || []).forEach(function (f) { if (preisVon(d, f) === undefined) offen.push([d, f]); });
    });
    if (!offen.length) return;
    rechnet = true;
    var eins = function () {
      var x = offen.shift();
      if (x) {
        var d = x[0], zus = stilZusatz(d);
        var s = {}; for (var k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) s[k] = z[k]; }
        s.serie = d.serie; s.farbe = x[1]; s.zusatz = zus; s.plan = {}; s.hoff = {}; s.xpos = {}; s.wahl = {};
        s.wunsch = wunschFertig();
        var r = K.startKueche(s, d);
        if (r) { s.plan = r.plan; s.hoff = r.hoff; s.xpos = r.xpos; s.wahl = r.wahl; }
        /* Die Sockelleiste gehoert standardmaessig dazu — sonst spraenge der Preis beim Oeffnen der Kueche. */
        s.zubehoer = {};
        if (r && sockelAn()) { var sp = sockelPaket(s, d); if (sp) s.zubehoer = sp.zubehoer; }
        preise[raumSchluessel(d.serie, x[1], zus)] = r ? K.gesamt(s, d) : null;
      }
      if (offen.length) { w.setTimeout(eins, 0); return; }
      rechnet = false;
      if (schirm === 'stil') { stilPreiseZeigen(); fussZeigen(); }
    };
    w.setTimeout(eins, 0);
  }
  function abPreis(name) {
    var d = kataloge[name];
    if (!d) return undefined;
    var werte = (d.farben || []).map(function (f) { return preisVon(d, f); });
    if (werte.some(function (v) { return v === undefined; })) return undefined;
    var da = werte.filter(function (v) { return v != null; });
    return da.length ? Math.min.apply(null, da) : null;
  }
  /* Der genaue Betrag, mit Cent. Abgeschnitten stuende „ab 2.759" ueber einer Kueche, die
     2.759,88 kostet — eine Preisangabe unter dem wirklichen Preis. */
  function euro(n) { return K.eur(n); }

  /* Foto der Komplettkueche je Serie und Farbe (aus den Einstellungen des Abschnitts). Ohne
     gewaehlte Farbe zeigt die Karte die erste eingetragene. */
  function stilBild(serie, farbe) {
    var t = (CFG.stilbilder || {})[serie] || {};
    return t[farbe] || t[Object.keys(t)[0]] || '';
  }
  function bildTag(url, alt, gross) {
    if (!url) return '<span class="hm-app__bild hm-app__bild--leer" data-url=""></span>';
    var u = function (b) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + b; };
    return '<img class="hm-app__bild" src="' + u(480) + '" srcset="' + [320, 480, 720, 960].map(function (b) { return u(b) + ' ' + b + 'w'; }).join(', ')
      + '" sizes="' + (gross ? '(min-width: 768px) 25vw, 50vw' : '50vw') + '" alt="' + esc(alt) + '" width="480" height="360" data-url="' + esc(url) + '">';
  }

  var AUSFUEHRUNG_KURZ = { 'Griff aus Metall': 'Mit Griff', 'Push-to-Open Mechanismus': 'Grifflos (Push)' };

  /* KEINE PREISE AUF DIESEM SCHRITT (Betreiber 2026-09-27: „لماذا تظهر الاسعار في هذه الصفحة"). Hier stand „ab …" —
     der Preis der Startkueche OHNE den Planungsrabatt, in der Kueche danach mit Rabatt: hier wirkte sie teurer, und die
     Zahlen passten nicht zusammen. Der Preis steht jetzt nur in der Kueche. Geblieben ist, was die Rechnung sonst
     verraet: passt die Serie ueberhaupt in diesen Raum. Sonst die Zahl der Farben. */
  function stilPreiseZeigen() {
    $$('[data-preis-serie]').forEach(function (el) {
      var name = el.getAttribute('data-preis-serie'), p = abPreis(name), d = kataloge[name];
      var n = d && d.farben ? d.farben.length : 0;
      el.textContent = p === null ? 'passt nicht in diesen Raum' : (n ? n + (n === 1 ? ' Farbe' : ' Farben') : '');
    });
  }

  /* Die Karten werden EINMAL gebaut und danach nur nachgefuehrt. Neu gebaut blieben die vier
     Bilder bei jedem Farbklick einen Augenblick leer — die Karte flackerte unter dem Finger. */
  function kartenNachfuehren(box) {
    K.SERIEN.forEach(function (s) {
      var b = box.querySelector('[data-serie="' + s.name + '"]');
      if (!b) return;
      var an = z.serie === s.name;
      b.setAttribute('aria-pressed', String(an));
      var img = b.querySelector('.hm-app__bild'), url = stilBild(s.name, an ? z.farbe : '');
      if (img && img.getAttribute('data-url') !== url) {
        var huelle = doc.createElement('span');
        huelle.innerHTML = bildTag(url, 'Küche ' + s.name + (an && z.farbe ? ' in ' + z.farbe : ''), true);
        img.parentNode.replaceChild(huelle.firstChild, img);
      }
    });
  }

  /* Flaeche einer Farbkachel: Holzdekor als Bild (CFG.dekore, wie in 3D), Hochglanz mit Lichtkante, sonst die Farbe. */
  function flaeche(name, hex) {
    var n = String(name || '').toLowerCase(), dek = CFG.dekore || {};
    var holz = Object.keys(dek).filter(function (k) { return n.indexOf(k) > -1 && dek[k]; })[0];
    if (holz) return 'background:' + (hex || '#b08a60') + ' url(' + dek[holz] + ') center/cover';
    if (/hochglanz/.test(n)) return 'background:linear-gradient(160deg,rgba(255,255,255,.55) 0,rgba(255,255,255,0) 38%),' + (hex || '#ccc');
    return 'background:' + (hex || '#ccc');
  }

  function stilZeigen() {
    var box = $('[data-app-stil]');
    alleLaden();
    var farben = daten && daten.serie === z.serie ? K.farbliste(daten, z.zusatz) : [];
    var zo = daten && daten.serie === z.serie ? (daten.zusatzoptionen || {}) : {};
    var aus = K.optGlobal(daten || {}).filter(function (g) { return (zo[g] || []).length > 1; });
    if (!box.querySelector('.hm-app__serien')) {
      box.innerHTML = '<div class="hm-app__serien" role="group" aria-label="Serie">'
        + K.SERIEN.map(function (s) {
          return '<button type="button" class="hm-app__serie" data-serie="' + s.name + '" aria-pressed="false">'
            + bildTag(stilBild(s.name, ''), 'Küche ' + s.name, true)
            + '<span class="hm-app__serietext"><b>' + s.name + '</b><span data-preis-serie="' + s.name + '"></span></span></button>';
        }).join('') + '</div><div data-app-stilrest></div>';
      box.querySelectorAll('[data-serie]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = b.getAttribute('data-serie');
          if (n === z.serie && daten && daten.serie === n) return;
          startVerwerfen();
          serieLaden(n);
        });
      });
    }
    kartenNachfuehren(box);
    var rest = box.querySelector('[data-app-stilrest]');
    rest.innerHTML = (laedt ? '<p class="hm-app__klein" role="status">Katalog ' + esc(laedt) + ' wird geladen …</p>' : '')
      + (ladeFehler ? '<p class="hm-app__hinweis hm-app__fehler" role="alert">' + esc(ladeFehler) + '</p>' : '')
      + (farben.length && !laedt
        ? '<div class="hm-app__farbkopf"><span class="hm-app__lab">Farbe</span><span class="hm-app__farbname">' + esc(z.farbe) + '</span></div>'
          /* FARBKACHELN (Betreiber 2026-09-27: „ولماذا الصور وطريقة اختيارها ليست احترافية"): bis hierher geteilte Kreise ohne
             Namen, die Reihe lief rechts aus dem Bild. Jetzt eine Kachel je Farbe mit Namen: oben die Front, unten als Band
             der Korpus (bei „Front / Korpus"); Holz mit der echten Maserung (dieselben Dekorbilder wie in 3D). */
          + '<div class="hm-app__farben" role="group" aria-label="Farbe">' + farben.map(function (f) {
            var zwei = f.name.split('/').map(function (x) { return x.trim(); });
            var korpus = zwei.length > 1 ? zwei[1] : null;
            return '<button type="button" class="hm-app__farbe" data-farbe="' + esc(f.name) + '" aria-pressed="' + (z.farbe === f.name) + '">'
              + '<span class="hm-app__muster" style="' + esc(flaeche(zwei[0], f.hex)) + '">'
              + (korpus ? '<i style="' + esc(flaeche(korpus, K.frontFarbe({ serie: z.serie, farbe: korpus }))) + '"></i>' : '') + '</span>'
              + '<span class="hm-app__farbtext">' + esc(f.name) + '</span></button>';
          }).join('') + '</div>'
        : '')
      + (aus.length && !laedt ? aus.map(function (g) {
        return '<div class="hm-app__chips hm-app__aus" role="group" aria-label="' + esc(g) + '">' + zo[g].map(function (v) {
          return '<button type="button" class="hm-app__chip" data-aus="' + esc(g) + '" data-wert="' + esc(v) + '" aria-pressed="' + ((z.zusatz || {})[g] === v) + '">' + esc(AUSFUEHRUNG_KURZ[v] || v) + '</button>';
        }).join('') + '</div>';
      }).join('') : '');

    rest.querySelectorAll('[data-farbe]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (z.farbe === b.getAttribute('data-farbe')) return;
        startVerwerfen();
        z.farbe = b.getAttribute('data-farbe'); merken(); zeigen();
      });
    });
    rest.querySelectorAll('[data-aus]').forEach(function (b) {
      b.addEventListener('click', function () {
        startVerwerfen();
        var zus = {}; for (var k in (z.zusatz || {})) { if (Object.prototype.hasOwnProperty.call(z.zusatz, k)) zus[k] = z.zusatz[k]; }
        zus[b.getAttribute('data-aus')] = b.getAttribute('data-wert');
        z.zusatz = zus; merken(); zeigen();
      });
    });
    stilPreiseZeigen();
    preiseRechnen();
  }

  /* ================= Bildschirm 3: Ihre Kueche =================

     Oben die Wand, wie sie gebaut wird (Frontansicht aus dem Kern, ohne Loeschkreuze — geloescht
     wird im Blatt, wo Platz fuer einen ordentlichen Knopf ist). Tippen waehlt einen Schrank.
     Unten das Blatt, in drei Zustaenden:
       ueberblick  nichts gewaehlt: ein Satz, die Schraenke dieser Wand als Knoepfe, „Schrank hinzufuegen"
       auswahl     ein Schrank gewaehlt: Ersetzen-Leiste, Anschlag, ← →, Entfernen
       hinzu       Modelle, die an dieser Wand noch Platz haben
     Jede Aenderung geht ueber den Kern (setzen, ersetzen) und wird mit der Kassenpruefung
     verglichen: was die Kasse ablehnen wuerde, bietet das Blatt gar nicht erst an. */

  var blattModus = 'ueberblick', hinzuReihe = 'unten', ansichtDrei = ansichtStart();

  /* 3D zuerst (UX 2026-09-27): die Kueche soll beim ersten Blick wie eine Kueche aussehen, nicht
     wie ein Bauplan. Die Wahl des Kunden (2D/3D) bleibt gemerkt. 2D bleibt der Anfang, wo 3D
     nichts taugt: ohne WebGL, mit Datensparmodus, oder wenn der Abschnitt 3D abschaltet. */
  var ANSICHT_MARKE = 'hmk-app-ansicht';
  function ansichtStart() {
    if (CFG.dreiD === false || !w.HMKonfig3D) return false;
    try { var m = w.localStorage.getItem('hmk-app-ansicht'); if (m) return m === '3d'; } catch (e) { /* */ }
    try { if (w.navigator.connection && w.navigator.connection.saveData) return false; } catch (e) { /* */ }
    try {
      var c = doc.createElement('canvas'), gl = c.getContext('webgl2') || c.getContext('webgl');
      /* Den Probe-Kontext gleich freigeben: iOS zaehlt offene WebGL-Kontexte. */
      var los = gl && gl.getExtension('WEBGL_lose_context'); if (los) los.loseContext();
      return !!gl;
    } catch (e) { return false; }
  }
  function ansichtMerken() {
    try { w.localStorage.setItem(ANSICHT_MARKE, ansichtDrei ? '3d' : '2d'); } catch (e) { /* */ }
  }

  function wandName(id) {
    var zwei = K.raumGeometrie(z).bloecke.some(function (b) { return b.id === 'IH'; });
    var f = { A: null, B: null, C: null, I: zwei ? 'Insel Raumseite' : 'Insel', IH: 'Insel Küchenseite' };
    if (z.form === 'l') { f.A = 'Hauptwand'; f.B = 'Seitenwand'; }
    else if (z.form === 'u') { f.A = 'Hauptwand'; f.B = 'Rechte Wand'; f.C = 'Linke Wand'; }
    else if (z.form === 'insel' && z.inselBasis === 'l') { f.A = 'Hauptwand'; f.B = 'Seitenwand'; }
    else if (z.form === 'insel' && z.inselBasis === 'u') { f.A = 'Hauptwand'; f.B = 'Rechte Wand'; f.C = 'Linke Wand'; }
    else if (z.form === 'insel') { f.A = 'Wand'; }
    else if (z.form === 'gerade') { f.A = 'Küchenzeile'; }
    else if (z.form === 'zweizeilig') { f.A = 'Hauptwand'; f.B = 'Abstand'; f.C = 'Gegenüber'; }
    return f[id] || K.wandObj(z, id).label;
  }
  function schrankWaende() {
    return K.wandAuswahl(z, 'schrank').map(function (w) { return w.id; });
  }
  /* Steht die Planung gerade auf der Insel? Dort gibt es nur Unterschraenke (wie K.katalog). */
  function aufBlock() {
    return K.raumGeometrie(z).bloecke.some(function (b) { return b.id === z.wand; });
  }
  function fehlerZahl(st) { return K.fehlerTexte(st, daten).length; }
  function mit(r) {
    var s = {}; for (var k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) s[k] = z[k]; }
    s.plan = r.plan; s.hoff = r.hoff; s.xpos = r.xpos; s.wahl = r.wahl;
    return s;
  }
  function uebernehmen(r) {
    rueckMerken();
    z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl;
    /* Eigener Geschirrspueler: die Nische ist ein Merkmal, kein Schrank (K.stellplatzStatt). */
    if (r.merkmale) { z.merkmale = r.merkmale; z.mid = r.mid; }
    if (r.sel !== undefined) z.sel = r.sel;
    inselAbgleichen(r.sel ? String(r.sel).split('|')[0] : z.wand);
    merken();
  }
  /* Doppelinsel: jede Aenderung an einer Seite spiegelt der Kern auf die andere (K.inselSpiegeln).
     Gesagt wird nur, was drueben WIRKLICH anders wurde: bleibt gegenueber eine Spuele stehen, hiesse
     „auf beiden Inselseiten" etwas Falsches; faellt drueben etwas mit weg, steht es beim Namen da. */
  var inselGespiegelt = null;
  function inselAbgleichen(wand) {
    if (wand !== 'I' && wand !== 'IH') return;
    var r = K.inselSpiegeln(z, daten, wand);
    if (!r) return;
    z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl;
    /* Der Kern ordnet die Reihe nach ihrer Stelle an der Insel — die Auswahl wandert mit. */
    var t = z.sel ? String(z.sel).split('|') : null;
    if (t && t[0] === wand && t[1] === 'boden' && r.neuIndex && r.neuIndex[t[2]] != null) z.sel = wand + '|boden|' + r.neuIndex[t[2]];
    inselGespiegelt = !r.anders ? null : (r.weg.length ? r.weg.map(kurzName) : []);
  }
  /* Ein gesicherter, umgebauter oder zurueckgeholter Plan steht auf der Doppelinsel ebenso lueckenlos
     und gespiegelt da. Staende aus der Zeit vor 2026-09-26 konnten versetzt sein (Betreiber-Bild: Stufe
     in der Platte) und blieben es bis zur naechsten Aenderung an der Insel. Auf einem Plan, der schon
     stimmt, aendert das nichts. */
  function inselNormal() {
    if (!daten || !K.raumGeometrie(z).bloecke.some(function (b) { return b.id === 'IH'; })) return;
    var r = K.inselSpiegeln(z, daten, 'I');
    if (!r) return;
    z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl;
    var t = z.sel ? String(z.sel).split('|') : null;
    if (t && t[1] === 'boden' && (t[0] === 'I' || t[0] === 'IH')) z.sel = t[0] === 'I' && r.neuIndex[t[2]] != null ? 'I|boden|' + r.neuIndex[t[2]] : null;
  }
  /* EIGENER GESCHIRRSPUELER (Betreiber 2026-09-26): die Nische ohne Front ist ein Merkmal des Kerns
     (Stellplatz). Gewaehlt heisst sie 'stell|<id>'. */
  function stellplaetze(wand) {
    return (z.merkmale || []).filter(function (m) {
      return K.MT[m.typ] && K.MT[m.typ].stellplatz && (!wand || m.wand === wand);
    });
  }
  function stellGewaehlt() {
    var t = z.sel ? String(z.sel).split('|') : null;
    if (!t || t[0] !== 'stell') return null;
    return stellplaetze().filter(function (m) { return String(m.id) === t[1]; })[0] || null;
  }
  function ohneFrontErlaubt(wand) {
    return !(doppelInsel() && K.raumGeometrie(z).bloecke.some(function (b) { return b.id === wand; }));
  }
  function gewaehlt() {
    var t = z.sel ? String(z.sel).split('|') : null;
    if (!t || t.length < 3 || !daten) return null;
    var key = t[0] + '|' + t[1], i = +t[2], arr = (z.plan || {})[key] || [];
    var m = daten.modelle[arr[i]];
    if (!m) return null;
    var it = K.items(z, daten, t[0], t[1]).filter(function (x) { return x.i === i; })[0];
    return { key: key, wand: t[0], zl: t[1], i: i, mi: arr[i], m: m, it: it, n: arr.length };
  }
  function preisVonModell(m, wahl) {
    var v = K.variante(m, z.farbe, K.zusatzMit(daten, z.zusatz, wahl));
    return v ? v.preis : null;
  }
  function bildVon(m) {
    var v = K.variante(m, z.farbe, z.zusatz);
    return (v && v.img) || '';
  }
  function breiteText(m) { return K.r0(K.nennMass(m)) + ' cm'; }

  /* NAMEN STATT CODES. Betreiber 2026-09-24: „der Kunde kennt die Codes nicht". D60S3, G60KN,
     D90N sagen dem Kunden nichts; „3 Schubladen", „Hängeschrank flach", „Eckschrank" schon. Die
     Codes bleiben im Beleg (dort wird bestellt) und sonst nirgends. Abgeleitet aus Funktion,
     Hoehe und der Schubladenzahl im Code — nicht aus dem Produkttitel, der je Serie anders
     formuliert ist. */
  function kurzName(m) {
    var f = m.funktion, c = String(m.code || '').toUpperCase().split('+')[0].replace(/^KU-/, '');
    var sch = (c.match(/^D\d+S(\d)/) || [])[1];
    var namen = {
      /* Wie die Produkttitel im Shop (Betreiber 2026-09-26: marktübliche Namen) — der Schrank, nicht das
         Gerät: verkauft wird der Spülenschrank, nicht die Spüle. Die Zeichnung zeigt weiter kurze Wegweiser
         (zeichenName). */
      spuelen_unterschrank: 'Spülenschrank', geschirrspuelerfront: 'Geschirrspülerfront', herdumbau: 'Herdumbauschrank',
      geraete_unterschrank: 'Backofenschrank', eck_unterschrank: 'Eckunterschrank', apotheker: 'Apothekerschrank',
      kuehlumbau: 'Kühlumbauschrank', hochschrank_geraet: 'Backofen-Hochschrank', hochschrank: 'Hochschrank',
      aufsatzschrank: 'Aufsatzschrank', eck_haengeschrank: 'Eckhängeschrank',
      /* Velora fuehrt ihn als „Oberschrank ueber der Dunstabzugshaube" — ein flacher Haengeschrank,
         kein Abzug. „Dunstschrank" las sich wie ein Geraet, erst recht obendrauf gestapelt. */
      haengeschrank_dunst: 'Hängeschrank flach',
      haengeschrank_glas: 'Vitrine'
    };
    /* Zwei Geschirrspuelerfronten gleicher Breite (Velora, Glanzia) standen als zwei gleiche Karten
       „Geschirrspüler" da — mit gleichem Bild (Betreiber 2026-09-26). Die halbhohe (57 cm) gehoert zu einem
       teilintegrierten Geraet, die volle (71,3 cm) zu einem vollintegrierten. */
    if (f === 'geschirrspuelerfront') return m.h < 65 ? 'Geschirrspülerfront teilintegriert' : 'Geschirrspülerfront vollintegriert';
    /* Name aus dem Katalog, wo die Funktion allein nicht reicht (Glanzia D20W „Weinregal", 2026-09-26). */
    if (m.kurzname) return m.kurzname;
    /* Zwei 60er ohne Schubladen (Glanzia D60 / D60 P/L): die Tuerzahl unterscheidet sie. */
    if (f === 'unterschrank' && m.tueren) return m.tueren === 1 ? 'Unterschrank 1 Tür' : 'Unterschrank ' + m.tueren + ' Türen';
    if (namen[f]) return namen[f];
    if (f === 'haengeschrank') return m.h <= 40 ? 'Hängeschrank flach' : 'Hängeschrank';
    if (K.istRegal(m)) return 'Regal';
    if (sch === '1') return 'Schublade + Tür';
    if (sch) return sch + ' Schubladen';
    return 'Unterschrank';
  }
  /* In der ZEICHNUNG: kurze Wegweiser nach dem Gerät, das dort steht („Spüle“, „Herd“) — sie müssen auf dem
     Telefon in einen 60-cm-Schrank passen, sonst blendet beschriftungEinpassen sie aus. */
  function zeichenName(m) {
    var marke = { spuelen_unterschrank: 'Spüle', herdumbau: 'Herd', geraete_unterschrank: 'Backofen', kuehlumbau: 'Kühlschrank',
      hochschrank_geraet: 'Backofen', geschirrspuelerfront: 'Geschirrspüler', eck_unterschrank: 'Eckschrank' };
    return marke[m.funktion] || kurzName(m);
  }
  function preisText(m, wahl) { var p = preisVonModell(m, wahl); return p == null ? '' : K.eur(p); }
  function differenz(d) {
    if (Math.abs(d) < 0.005) return 'gleicher Preis';
    return (d > 0 ? '+' : '−') + K.eur(Math.abs(d));
  }

  /* ---------- Die Zeichnung ---------- */

  /* Code und Name im Schrank: eingeblendet, wenn sie hineinpassen, sonst gar nicht — dieselbe
     Regel wie im alten Planer (chipsMessen). Ein abgeschnittenes „D6" hilft niemandem. */
  function beschriftungEinpassen(svg) {
    if (!svg) return;
    Array.prototype.forEach.call(svg.querySelectorAll('[data-code],[data-name]'), function (t) {
      var platz = parseFloat(t.getAttribute('data-platz')) || 0, b = 0;
      try { b = t.getComputedTextLength(); } catch (e) { b = 0; }
      if (b) t.setAttribute('opacity', b + 4 <= platz ? '1' : '0');
    });
    Array.prototype.forEach.call(svg.querySelectorAll('[data-sel]'), function (g) {
      var schild = g.querySelector('[data-schild]'), linie = g.querySelector('[data-schildlinie]');
      if (!schild) return;
      var an = Array.prototype.some.call(g.querySelectorAll('[data-code],[data-name]'), function (t) { return t.getAttribute('opacity') !== '0'; });
      schild.setAttribute('opacity', an ? String(K.SCHILD_DECKUNG) : '0');
      if (linie) linie.setAttribute('opacity', an ? '1' : '0');
    });
  }

  /* Die Beschriftung eines Anschlusses („Wasseranschluss · 290 cm") steht in einem Feld neben seiner Plakette — dieselbe
     Regel wie im alten Planer (chipsMessen): in der gezeichneten Schrift gemessen, zuerst auf der vorgesehenen Seite,
     passt es dort nicht ins Bild, auf die andere; zwei auf derselben Hoehe liegen untereinander. Die App rief das nie
     auf: das Feld blieb 0 breit, der Text stand weiss auf der Front und lief rechts aus dem Bild („Wassera…"). Seit der
     Raum nach dem Wasseranschluss fragt (Stufe 2), steht er in jeder solchen Kueche. */
  function chipsLegen(svg) {
    if (!svg || !svg.viewBox || !svg.viewBox.baseVal) return;
    var vb = svg.viewBox.baseVal, links = vb.x, rechts = vb.x + vb.width, gelegt = [];
    Array.prototype.forEach.call(svg.querySelectorAll('[data-chip]'), function (g) {
      var kasten = g.querySelector('[data-chipbg]'), txt = g.querySelector('[data-chiptext]');
      if (!kasten || !txt) return;
      var lang = 0;
      try { lang = txt.getComputedTextLength(); } catch (e) { lang = 0; }
      if (!lang) return;
      var pad = parseFloat(g.getAttribute('data-pad')) || 0, cx = parseFloat(g.getAttribute('data-cx')) || 0;
      var gap = parseFloat(g.getAttribute('data-gap')) || 0, br = lang + pad * 2;
      var x0 = g.getAttribute('data-seite') === 'links' ? cx - gap - br : cx + gap;
      if (x0 + br > rechts) x0 = cx - gap - br;
      if (x0 < links) x0 = Math.max(links, Math.min(rechts - br, cx + gap));
      kasten.setAttribute('x', x0); kasten.setAttribute('width', br); txt.setAttribute('x', x0 + pad);
      gelegt.push({ kasten: kasten, txt: txt, x0: x0, br: br,
        y: parseFloat(kasten.getAttribute('y')) || 0, h: parseFloat(kasten.getAttribute('height')) || 0 });
    });
    gelegt.sort(function (a, b) { return a.y - b.y || a.x0 - b.x0; });
    var frei = [], reihen = Math.min(Math.max(gelegt.length, 2), 6);
    gelegt.forEach(function (c) {
      var reihe = 0, y = c.y;
      while (reihe < reihen && frei.some(function (o) {
        return Math.abs(o.y - y) < c.h * 0.9 && c.x0 < o.x0 + o.br && o.x0 < c.x0 + c.br;
      })) { reihe++; y = c.y + reihe * c.h * 1.25; }
      if (y !== c.y) {
        c.txt.setAttribute('y', (parseFloat(c.txt.getAttribute('y')) || 0) + (y - c.y));
        c.kasten.setAttribute('y', y); c.y = y;
      }
      frei.push(c);
    });
  }

  function zeichnungZeigen() {
    var box = $('[data-app-front]');
    if (!box || !daten) return;
    var drei = ansichtDrei && CFG.dreiD !== false && w.HMKonfig3D;
    box.hidden = !!drei;
    $('[data-app-drei]').hidden = !drei;
    /* 3D bekommt am Telefon mehr Hoehe (Betreiber 2026-09-27: „حجم شاشة المخطط ال 3d صغير على الموبايل"). */
    if (box.parentNode && box.parentNode.classList) box.parentNode.classList.toggle('is-drei', !!drei);
    if (drei) { dreiZeigen(); return; }
    /* Die Schrift rechnet der Kern aus der GEZEICHNETEN Breite. Die ist nicht die Breite des
       Kastens: `meet` passt die Wand in dessen Hoehe ein, und im Querformat (844 x 390) war die
       Zeichnung 450 px breit in einem 1640 px breiten Kasten — die Schrift wurde fuer 1640 px
       gerechnet und stand winzig da. Also: einmal zeichnen, die echte Breite ausrechnen, und
       wenn sie deutlich kleiner ist, mit ihr noch einmal. */
    var kastenB = box.clientWidth || 360, kastenH = box.clientHeight || 300;
    var f = K.frontZeichnung(z, daten, kastenB, true);
    var vb = String(f.vb).split(/\s+/).map(Number);
    var gezeichnet = vb[2] > 0 && vb[3] > 0 ? Math.min(kastenB, kastenH * vb[2] / vb[3]) : kastenB;
    if (gezeichnet < kastenB * 0.9) f = K.frontZeichnung(z, daten, gezeichnet, true);
    box.innerHTML = '<svg viewBox="' + f.vb + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Frontansicht '
      + esc(wandName(z.wand)) + '">' + f.inner + '</svg>';
    /* Im Schild steht der NAME statt des Codes; die zweite Zeile (Produkttitel) faellt weg.
       Ob er hineinpasst, entscheidet danach beschriftungEinpassen. */
    Array.prototype.forEach.call(box.querySelectorAll('svg [data-sel]'), function (g) {
      var t = String(g.getAttribute('data-sel')).split('|');
      var m = daten.modelle[((z.plan || {})[t[0] + '|' + t[1]] || [])[+t[2]]];
      if (!m) return;
      var code = g.querySelector('[data-code]'), name = g.querySelector('[data-name]');
      if (code) code.textContent = zeichenName(m);
      if (name) name.parentNode.removeChild(name);
    });
    beschriftungEinpassen(box.querySelector('svg'));
    /* Die gewaehlte Nische (eigener Geschirrspueler) sichtbar machen — der Kern markiert nur Schraenke. */
    var nsel = stellGewaehlt(), nrect = nsel && box.querySelector('svg [data-mk="' + nsel.id + '"] rect');
    if (nrect) { nrect.setAttribute('stroke', 'var(--hm-ink)'); nrect.setAttribute('stroke-width', '1.6'); }
    /* Der Kern beschriftet die Wand mit ihrer Kennung („Wand A"). In der App heisst sie, wie
       der Kunde sie im ersten Bildschirm kennengelernt hat (PLAN §3: kein „Wand A"). */
    var alt = K.wandObj(z).label;
    Array.prototype.forEach.call(box.querySelectorAll('svg text'), function (t) {
      if (t.textContent === alt) t.textContent = wandName(z.wand);
      /* Die Nische heisst in der App so, wie der Kunde sie gewaehlt hat. */
      else if (/^Stellplatz Geschirrspüler /.test(t.textContent)) t.textContent = t.textContent.replace('Stellplatz Geschirrspüler', 'Eigener Geschirrspüler');
      else if (/^Stellplatz Kühlschrank /.test(t.textContent)) t.textContent = t.textContent.replace('Stellplatz Kühlschrank', 'Eigener Kühlschrank');
    });
    /* Erst nach dem Umbenennen: gemessen wird der Text, der stehen bleibt. */
    chipsLegen(box.querySelector('svg'));
  }
  /* Dasselbe fuer die Pruefsaetze des Kerns: „Wand A: …" wird „Hauptwand: …", bei der
     Kuechenzeile faellt die Wand ganz weg — es gibt nur eine. */
  function kundenText(t) {
    return String(t || '').replace(/^(Wand [A-C]|Insel(?: vorne)?): /, function (x, name) {
      var id = name === 'Insel' || /^Insel/.test(name) ? 'I' : name.slice(-1);
      return z.form === 'gerade' && id === 'A' ? '' : wandName(id) + ': ';
    }).replace(/^./, function (c) { return c.toUpperCase(); });
  }

  var leinwand = null, dreiLaedt = false, dreiFehler = null, dreiGebaut = false;
  /* Ein Wandknopf wartet auf die 3D-Kamera — auch einer, der in 2D gedrueckt wurde: wer danach auf 3D
     schaltet, sieht dieselbe Wand wie eben in der Zeichnung. */
  var wandBlickOffen = false;
  /* Was die 3D-Ansicht gerade zeigt: 'raum' (ganze Kueche), 'wand' (eine Wand) oder 'frei' (selbst gedreht) — fuer die
     Knoepfe oben (wandChipsZeigen). */
  var dreiBlick = 'raum';
  /* Der Foto-Knopf: rechnet ein Standbild, zeigt den Fortschritt und bietet es danach zum
     Speichern an. Jede Bewegung in der Ansicht bricht das Foto ab (das 3D-Modul). */
  /* Eine Objektadresse haelt das Bild im Speicher, bis sie freigegeben wird. */
  var fotoNr = 0;
  function fotoUrlFrei(a) {
    var h = a && a.getAttribute('href');
    if (h && h.indexOf('blob:') === 0) { try { URL.revokeObjectURL(h); } catch (e) { /* */ } }
    if (a) a.removeAttribute('href');
  }
  function fotoKnopf(box, sagen) {
    var k = box.querySelector('[data-foto]'), sp = box.querySelector('[data-foto-speichern]');
    if (!k || k.dataset.an || typeof w.HMKonfig3D.foto !== 'function') return;
    k.dataset.an = '1';
    /* „Bild speichern" steht AN DER STELLE von „Foto" (Betreiber 2026-09-28), solange das Standbild
       zu sehen ist. Jede Bewegung beendet es (3D-Modul) — dann kommt „Foto" zurueck. */
    w.HMKonfig3D.beimFotoEnde = function () {
      var f = doc.activeElement === sp;
      fotoNr++;
      k.hidden = false; sp.hidden = true; fotoUrlFrei(sp);
      if (f) k.focus({ preventScroll: true });
    };
    /* Nach dem ersten Bild rechnet der Desktop weiter (3D-Modul): „Bild speichern" bekommt jeweils die
       schaerfere Datei, die Zeile sagt, dass es noch besser wird. */
    w.HMKonfig3D.beimFotoBesser = function (bild, anteil) {
      var nr = fotoNr;
      Promise.resolve().then(bild).then(function (url) {
        if (!url) return;
        if (nr !== fotoNr || sp.hidden) { if (url.indexOf('blob:') === 0) URL.revokeObjectURL(url); return; }
        fotoUrlFrei(sp);
        sp.href = url;
        sagen(anteil >= 1 ? 'Foto fertig. Ziehen kehrt zur Live-Ansicht zurück.'
          : 'Foto fertig – wird noch schärfer … ' + Math.round(anteil * 100) + ' %');
      }).catch(function () { /* das vorige Bild bleibt */ });
    };
    k.addEventListener('click', function () {
      if (w.HMKonfig3D.fotoLaeuft()) { w.HMKonfig3D.fotoStop(); k.textContent = 'Foto'; sagen('Foto abgebrochen.'); return; }
      sp.hidden = true;
      k.textContent = 'Abbrechen';
      sagen('Foto wird berechnet … 0 %');
      w.HMKonfig3D.foto(function (a) { sagen('Foto wird berechnet … ' + Math.round(a * 100) + ' %'); }).then(function (r) {
        k.textContent = 'Foto';
        if (r.abgebrochen) { sagen(bedienText()); return; }
        sagen(r.weiter ? 'Foto fertig – wird noch schärfer … 0 %' : 'Foto fertig. Ziehen kehrt zur Live-Ansicht zurück.');
        /* Die Datei entsteht asynchron (Blob) — erst dann tritt „Bild speichern" an die Stelle von „Foto". */
        var nr = fotoNr;
        Promise.resolve().then(r.bild).then(function (url) {
          if (!url) return;
          /* Inzwischen bewegt? Dann gilt das Bild nicht mehr. */
          if (nr !== fotoNr) { if (url.indexOf('blob:') === 0) URL.revokeObjectURL(url); return; }
          fotoUrlFrei(sp);
          sp.href = url;
          var f = doc.activeElement === k;
          sp.hidden = false; k.hidden = true;
          if (f) sp.focus({ preventScroll: true });
        }).catch(function () { /* ohne Bild kein Speichern */ });
      }).catch(function () {
        k.textContent = 'Foto';
        sagen('Das Foto lässt sich auf diesem Gerät nicht berechnen.');
      });
    });
  }
  /* Maus oder Finger: auf dem Desktop hiess es „Tippen … 2 Finger zoomen" (UX 2026-09-27). */
  function bedienText() {
    var maus = false;
    try { maus = w.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { /* */ }
    return maus ? 'Klicken wählt · Ziehen dreht · Mausrad zoomt' : 'Tippen wählt · Ziehen dreht · 2 Finger zoomen';
  }
  function dreiZeigen() {
    var box = $('[data-app-drei]'), meld = $('[data-app-dreimeldung]');
    if (!leinwand) { leinwand = doc.createElement('canvas'); leinwand.className = 'hm-app__leinwand'; box.insertBefore(leinwand, box.firstChild); }
    var sagen = function (t) { if (meld) meld.textContent = t || ''; };
    if (dreiFehler) { sagen(dreiFehler); return; }
    if (w.HMKonfig3D.bereit()) {
      if (!(w.HMKonfig3D.fotoLaeuft && w.HMKonfig3D.fotoLaeuft())) sagen(bedienText());
      /* Die Szene wird hier neu gebaut — ein zuvor gerechnetes Foto zeigt dann eine andere Kueche
         (gesehen 2026-09-27: nach dem Serienwechsel bot „Bild speichern" noch das alte Bild an). */
      var spAlt = box.querySelector('[data-foto-speichern]');
      if (spAlt) { spAlt.hidden = true; fotoUrlFrei(spAlt); }
      var kAlt = box.querySelector('[data-foto]');
      if (kAlt) kAlt.hidden = false;
      fotoKnopf(box, sagen);
      /* Antippen in 3D waehlt wie in der Zeichnung; ein Tipper ins Leere hebt die Wahl auf. */
      w.HMKonfig3D.beimAntippen = function (sel) {
        if (sel) { if (!/^stell\|/.test(sel) && sel.split('|')[0] !== z.wand) z.wand = sel.split('|')[0]; waehlen(sel); }
        else if (z.sel) { z.sel = null; blattModus = 'ueberblick'; kuecheZeigen(); }
      };
      var neuAufgebaut = !dreiGebaut;
      if (w.HMKonfig3D.dekore) w.HMKonfig3D.dekore(CFG.dekore);
      if (w.HMKonfig3D.dekoModelle) w.HMKonfig3D.dekoModelle(CFG.dekoModelle);
      if (w.HMKonfig3D.aussicht && CFG.aussicht) w.HMKonfig3D.aussicht(CFG.aussicht);
      w.HMKonfig3D.szene(leinwand, z, daten);
      /* Der erste Blick ist die RAUMANSICHT (Betreiber 2026-09-28: „نعم ابدا اريده بشكل احترافي وذكي"): die Kueche wie
         auf einem Foto, aus dem Raum in Augenhoehe, die Kamera sucht sich die beste Stelle (3D-Modul). Ziehen fuehrt in die
         freie Perspektive, die Wandknoepfe zeigen jede Wand; laesst sich keine Raumansicht rechnen, zeigt das Modul die
         Perspektive wie bisher. Nur beim ersten Aufbau — danach bleibt die Kamera, wo der Kunde sie hingedreht hat. */
      if (neuAufgebaut) { w.HMKonfig3D.blick('raum', z.wand); dreiGebaut = true; dreiBlick = 'raum'; }
      if (wandBlickOffen) { wandBlickOffen = false; w.HMKonfig3D.blick('front', z.wand); dreiBlick = 'wand'; }
      /* Wer selbst dreht, steht auf keiner der Ansichten mehr — kein Knopf behauptet sie dann. */
      w.HMKonfig3D.beimDrehen = function () { if (dreiBlick !== 'frei') { dreiBlick = 'frei'; wandChipsZeigen(); } };
      w.HMKonfig3D.markieren(z.sel);
      return;
    }
    if (dreiLaedt) { sagen('Die 3D-Ansicht wird geladen …'); return; }
    dreiLaedt = true;
    sagen('Die 3D-Ansicht wird geladen …');
    /* Ohne WebGL oder ohne Bibliothek bleibt es still bei 2D (PLAN §3). */
    w.HMKonfig3D.laden(CFG.dreiQuelle || 'https://esm.sh/three@0.160.0').then(function () {
      dreiLaedt = false;
      if (ansichtDrei) dreiZeigen();
    }).catch(function () {
      dreiLaedt = false;
      dreiFehler = '3D ist auf diesem Gerät nicht verfügbar — die Zeichnung zeigt dieselbe Küche.';
      ansichtDrei = false;
      kuecheZeigen();
    });
  }

  /* ---------- Das Blatt ---------- */

  function doppelInsel() { return K.raumGeometrie(z).bloecke.some(function (b) { return b.id === 'IH'; }); }
  function ersatzListe(g) {
    var s = {}; for (var k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) s[k] = z[k]; }
    s.wand = g.wand;
    var altPreis = preisVonModell(g.m, K.wahlListe(z, g.key)[g.i]);
    /* In der Bodenreihe stehen Unter- UND Hochschraenke — getauscht werden darf zwischen beiden
       (hoher Backofen, Kuehlschrank; Betreiber 2026-09-25). */
    var aufInsel = K.raumGeometrie(z).bloecke.some(function (b) { return b.id === g.wand; });
    var reihen = g.zl === 'boden' && !aufInsel ? ['unten', 'voll'] : [g.m.reihe];
    var angebot = [];
    reihen.forEach(function (rh) { angebot = angebot.concat(K.katalog(s, daten, rh, '')); });
    /* DOPPELINSEL: nur dieselbe Breite (Betreiber 2026-09-28) — sonst passt die Fuge nicht mehr
       zum Partner auf der anderen Seite, und die Insel steht versetzt Ruecken an Ruecken. */
    var gleichBreit = aufInsel && doppelInsel();
    return angebot.filter(function (x) {
      return x.i !== g.mi && K.istEck(x.m) === K.istEck(g.m)
        && (!gleichBreit || Math.round(K.nennMass(x.m)) === Math.round(K.nennMass(g.m)));
    }).map(function (x) {
      var r = K.ersetzen(z, daten, z.sel, x.i);
      if (r.sperre || r.fehler) return null;
      var neuPreis = preisVonModell(x.m, r.wahl[g.key][g.i]);
      return { x: x, r: r, diff: (neuPreis == null || altPreis == null) ? null : neuPreis - altPreis };
    }).filter(Boolean).sort(function (a, b) {
      return Math.abs(K.nennMass(a.x.m) - K.nennMass(g.m)) - Math.abs(K.nennMass(b.x.m) - K.nennMass(g.m))
        || (a.diff || 0) - (b.diff || 0);
    });
  }

  var HINZU_REIHEN = [{ k: 'unten', t: 'Unterschrank' }, { k: 'oben', t: 'Hängeschrank' }, { k: 'voll', t: 'Hochschrank' }];
  /* EBEN ENTFERNT (Betreiber 2026-09-27: „وفي حال حذف العميل خزانة من الجزيرة ان تكون له امكانية لاضافتها هي او غيرها"):
     je Wand der zuletzt entfernte Schrank (Modellindex). „Schrank hinzufügen" oeffnet danach in seiner Art und zeigt
     ihn ZUERST, mit „Eben entfernt" — vorher stand er irgendwo hinter den 30-cm-Schraenken. Die anderen folgen wie
     bisher nach Breite und Preis. Nur fuer diese Sitzung der Seite; „Rückgängig" und das Wiedereinsetzen loeschen ihn. */
  var zuletztWeg = {};
  function hinzuListe(reihe) {
    var vorher = fehlerZahl(z), weg = zuletztWeg[z.wand];
    /* Eckschraenke gehoeren dazu (Betreiber 2026-09-27: „die Eckschraenke oben und unten erscheinen
       nicht" — nach dem Entfernen liess sich keiner mehr einsetzen). K.setzen stellt sie an das
       freie Ende mit Ecke; wo keine freie Ecke ist, meldet die Pruefung einen Fehler mehr und
       die Karte faellt unten heraus. */
    return K.katalog(z, daten, reihe, '').map(function (x) {
      var gr = K.optGruppen(daten, x.m, z.farbe)[0];
      var r = K.setzen(z, daten, x.i, gr ? gr.werte[0] : null);
      if (r.sperre || r.fehler || fehlerZahl(mit(r)) > vorher) return null;
      return { x: x, r: r, eben: weg != null && x.i === weg };
    }).filter(Boolean).sort(function (a, b) {
      return (b.eben - a.eben) || K.nennMass(a.x.m) - K.nennMass(b.x.m) || (a.x.v.preis - b.x.v.preis);
    });
  }
  /* Warum passt gerade KEIN Eckschrank dieser Art? Ohne Satz dazu sah der Kunde nur, dass er
     fehlt (Betreiber 2026-09-27). Der Grund ist die erste NEUE Meldung der Pruefung, in seinen
     Wandnamen — z. B. ein Haengeschrank, der in die Ecke ragt. null, wenn einer passt oder die
     Serie in dieser Reihe keinen fuehrt. */
  function eckHinweis(reihe, liste) {
    /* Eine Insel hat keine Ecke — dort ist der Satz nur Laerm (gesehen 2026-09-27 beim Wiedereinsetzen auf der Insel). */
    if (aufBlock() || liste.some(function (e) { return K.istEck(e.x.m); })) return null;
    var vorher = K.fehlerTexte(z, daten), grund = null, name = null;
    K.katalog(z, daten, reihe, '').filter(function (x) { return K.istEck(x.m); }).some(function (x) {
      var gr = K.optGruppen(daten, x.m, z.farbe)[0];
      var r = K.setzen(z, daten, x.i, gr ? gr.werte[0] : null);
      name = kurzName(x.m);
      if (r.fehler) return false;
      /* Der Kern nennt das Modell beim Code („in die D90N passt"); der Kunde kennt nur den Namen davor. */
      if (r.sperre) { grund = kundenText(r.sperre).split('in die ' + x.m.code + ' passt').join('in die er passt'); return true; }
      var neu = K.fehlerTexte(mit(r), daten).filter(function (t) { return vorher.indexOf(t) < 0; })[0];
      if (neu) { grund = kundenText(neu); return true; }
      return false;
    });
    return grund ? name + ' passt hier gerade nicht: ' + grund : null;
  }
  function platzFrei() {
    var b = K.bilanz(z, daten, z.wand);
    var oben = K.nutzLaenge(z, daten, z.wand, 'oben') - K.belegtLaenge(z, daten, z.wand, 'oben');
    return b.frei >= 15 || (!aufBlock() && oben >= 15);
  }

  function karte(attr, m, zeile2, zeile3, marke) {
    var bild = bildVon(m);
    return '<button type="button" class="hm-app__modell" ' + attr + '>'
      + (bild ? '<img src="' + esc(bild) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="hm-app__modellbild"></span>')
      + (marke ? '<span class="hm-app__marke">' + esc(marke) + '</span>' : '')
      + '<b>' + esc(kurzName(m)) + '</b><span>' + esc(zeile2) + '</span>' + (zeile3 ? '<span class="hm-app__modellpreis">' + esc(zeile3) + '</span>' : '') + '</button>';
  }

  /* Karte fuer die Nische ohne Front: kein Produktbild — eine gestrichelte Nische mit Geraet. */
  var NISCHE_BILD = '<svg class="hm-app__modellbild hm-app__nischenbild" viewBox="0 0 72 72" width="72" height="72" aria-hidden="true">'
    + '<rect x="15" y="9" width="42" height="54" rx="2" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="5 4"/>'
    + '<rect x="21" y="16" width="30" height="41" rx="2" fill="currentColor" opacity=".16"/>'
    + '<rect x="21" y="16" width="30" height="7" rx="1.5" fill="currentColor" opacity=".38"/>'
    + '<line x1="27" y1="28" x2="45" y2="28" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  /* Der eigene Kuehlschrank (2026-09-26): eine raumhohe gestrichelte Nische mit freistehendem Geraet. */
  var NISCHE_BILD_KUEHL = '<svg class="hm-app__modellbild hm-app__nischenbild" viewBox="0 0 72 72" width="72" height="72" aria-hidden="true">'
    + '<rect x="20" y="4" width="32" height="64" rx="2" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="5 4"/>'
    + '<rect x="25" y="10" width="22" height="55" rx="2.5" fill="currentColor" opacity=".16"/>'
    + '<line x1="25" y1="30" x2="47" y2="30" stroke="currentColor" stroke-width="1.6" opacity=".55"/>'
    + '<line x1="43" y1="16" x2="43" y2="25" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
    + '<line x1="43" y1="35" x2="43" y2="48" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  function nischenKarte(attr, zeile2, zeile3, typ) {
    return '<button type="button" class="hm-app__modell" ' + attr + '>' + (typ === 'kuehl' ? NISCHE_BILD_KUEHL : NISCHE_BILD)
      + '<b>' + (typ === 'kuehl' ? 'Eigener Kühlschrank' : 'Eigener Geschirrspüler') + '</b><span>' + esc(zeile2) + '</span>'
      + (zeile3 ? '<span class="hm-app__modellpreis">' + esc(zeile3) + '</span>' : '') + '</button>';
  }
  /* Was an die Stelle der Nische passt: Geschirrspuelerfronten zuerst, dann Unterschraenke derselben
     Breite — jeweils nur, wenn der Kern es ohne neuen Fehler einsetzt. In die raumhohe Nische des
     Kuehlschranks passen Hochschraenke: der Kuehlumbau zuerst. */
  function stellAngebot(mk) {
    var kuehl = mk.typ === 'kuehl', erst = kuehl ? 'kuehlumbau' : 'geschirrspuelerfront';
    return K.katalog(z, daten, kuehl ? 'voll' : 'unten', '').filter(function (x) {
      return !K.istEck(x.m) && Math.abs(K.nennMass(x.m) - mk.breite) <= 0.5;
    }).map(function (x) {
      var gr = K.optGruppen(daten, x.m, z.farbe)[0], wahl = gr ? gr.werte[0] : null;
      var r = K.ausStellplatz(z, daten, mk.id, x.i, wahl);
      if (r.fehler || r.sperre) return null;
      return { x: x, r: r, preis: preisVonModell(x.m, wahl) || 0 };
    }).filter(Boolean).sort(function (a, b) {
      var fa = a.x.m.funktion === erst ? 0 : 1, fb = b.x.m.funktion === erst ? 0 : 1;
      return fa - fb || a.preis - b.preis;
    });
  }

  function blattZeigen() {
    var box = $('[data-app-blatt]');
    var g = gewaehlt(), sg = g ? null : stellGewaehlt();
    if (!g && !sg && blattModus === 'auswahl') blattModus = 'ueberblick';
    var o = [];
    if (blattModus === 'auswahl' && sg) {
      /* DIE NISCHE: was sie ist, und der Weg zurueck zu Front oder Schrank. */
      var ang = stellAngebot(sg), gh = K.geo(daten).korpus_hoehe, istKuehl = sg.typ === 'kuehl';
      o.push('<div class="hm-app__blattkopf"><div><b>' + (istKuehl ? 'Eigener Kühlschrank' : 'Eigener Geschirrspüler') + '</b><span>'
        + esc(K.r0(sg.breite) + ' cm Nische · ' + (istKuehl ? 'ohne Schrank' : 'ohne Front')) + '</span></div>'
        + '<button type="button" class="hm-app__chip" data-blatt="fertig">Fertig</button></div>');
      o.push(istKuehl
        ? '<p class="hm-app__klein">Für einen freistehenden Kühlschrank. Die Nische ist ' + esc(K.r0(sg.breite)) + ' cm breit und '
          + 'bis ' + esc(K.r0(sg.hoehe)) + ' cm hoch frei; die Arbeitsplatte endet davor, darüber hängt kein Schrank. '
          + 'Gerät und Anschluss sind nicht im Lieferumfang – bitte Breite, Tiefe, Höhe und Türanschlag vor der Bestellung prüfen.</p>'
        : '<p class="hm-app__klein">Für einen Geschirrspüler mit eigener Tür (Unterbau- oder Standgerät). Die Nische ist '
          + esc(K.r0(sg.breite)) + ' cm breit und ' + esc(K.r0(gh)) + ' cm hoch, die Arbeitsplatte läuft darüber. '
          + 'Gerät, Anschluss und Montage sind nicht im Lieferumfang – bitte die Gerätemaße vor der Bestellung prüfen.</p>');
      if (istKuehl) {
        var kfJetzt = wunschVon('kuehlFarbe'), kfFrage = FRAGEN.filter(function (q) { return q.k === 'kuehlFarbe'; })[0];
        o.push('<div class="hm-app__chips hm-app__anschlag" role="group" aria-label="Farbe des Kühlschranks"><span class="hm-app__lab">Farbe</span>'
          + kfFrage.a.map(function (a) {
            return '<button type="button" class="hm-app__chip" data-kuehlfarbe="' + a[0] + '" aria-pressed="' + (a[0] === kfJetzt) + '">' + esc(a[1]) + '</button>';
          }).join('') + '</div>');
      }
      if (istKuehl) o.push(lageChips({ typ: 'kuehl', stell: sg.id }));
      o.push('<span class="hm-app__lab">Stattdessen einsetzen</span>');
      o.push(ang.length
        ? '<div class="hm-app__leiste" role="list">' + ang.map(function (e, n) {
          return karte('role="listitem" data-ausnische="' + n + '"', e.x.m, breiteText(e.x.m), '+' + K.eur(e.preis));
        }).join('') + '</div>'
        : '<p class="hm-app__klein">An dieser Stelle passt kein Schrank dieser Breite.</p>');
      box.innerHTML = o.join('');
      lageBinden(box);
      box.querySelectorAll('[data-kuehlfarbe]').forEach(function (b) {
        b.addEventListener('click', function () {
          (z.wunsch = z.wunsch || {}).kuehlFarbe = b.getAttribute('data-kuehlfarbe');
          merken();
          sagen('Kühlschrank in ' + b.textContent + '.');
          kuecheZeigen();
        });
      });
      box.querySelectorAll('[data-ausnische]').forEach(function (b) {
        b.addEventListener('click', function () {
          var e = ang[+b.getAttribute('data-ausnische')];
          e.r.sel = sg.wand + '|boden|' + e.r.i;
          if (istKuehl) (z.wunsch = z.wunsch || {}).kuehl = e.x.m.funktion === 'kuehlumbau' ? 'einbau' : 'keiner';
          else (z.wunsch = z.wunsch || {}).gs = e.x.m.funktion === 'geschirrspuelerfront' ? (e.x.m.h < 65 ? 'teil' : 'voll') : 'keiner';
          uebernehmen(e.r);
          sagen(kurzName(e.x.m) + ' ' + breiteText(e.x.m) + ' eingesetzt.');
          kuecheZeigen();
        });
      });
    } else if (blattModus === 'auswahl' && g) {
      var gr = K.optGruppen(daten, g.m, z.farbe)[0], jetzt = K.wahlListe(z, g.key)[g.i];
      var liste = ersatzListe(g);
      o.push('<div class="hm-app__blattkopf"><div><b>' + esc(kurzName(g.m)) + '</b><span>' + esc(breiteText(g.m) + ' · ' + preisText(g.m, jetzt)) + '</span></div>'
        + '<button type="button" class="hm-app__chip" data-blatt="fertig">Fertig</button></div>');
      if (g.zl === 'boden' && g.m.reihe === 'voll') {
        o.push(lageChips({ typ: g.m.funktion === 'kuehlumbau' ? 'kuehl' : (g.m.funktion === 'hochschrank_geraet' ? 'ofen' : 'hoch'), wand: g.wand, i: g.i }));
      }
      o.push('<span class="hm-app__lab">Ersetzen durch</span>');
      if (doppelInsel() && K.raumGeometrie(z).bloecke.some(function (b) { return b.id === g.wand; })) {
        o.push('<p class="hm-app__klein">Doppelinsel: nur Modelle in ' + esc(breiteText(g.m)) + ' — so passen beide Seiten Rücken an Rücken zusammen.</p>');
      }
      /* EIGENER GESCHIRRSPUELER (Betreiber 2026-09-26): statt der Front nur die Nische — fuer ein
         Geraet mit eigener Tuer. Erste Karte der Leiste; nicht auf der Doppelinsel (dort sind die
         Seiten Paare). */
      /* Ebenso der EIGENE KUEHLSCHRANK (2026-09-26): statt des Kuehlumbaus eine raumhohe Nische. */
      var nischeTyp = g.m.funktion === 'kuehlumbau' ? 'kuehl' : 'spueler';
      var ohneFront = (g.m.funktion === 'geschirrspuelerfront' || g.m.funktion === 'kuehlumbau') && g.zl === 'boden' && ohneFrontErlaubt(g.wand)
        ? K.stellplatzStatt(z, daten, g.key + '|' + g.i) : null;
      if (ohneFront && (ohneFront.fehler || ohneFront.sperre)) ohneFront = null;
      var nischeHtml = ohneFront ? nischenKarte('role="listitem" data-ohnefront', (nischeTyp === 'kuehl' ? 'ohne Schrank · ' : 'ohne Front · ') + breiteText(g.m),
        differenz(-(preisVonModell(g.m, jetzt) || 0)), nischeTyp) : '';
      o.push(liste.length || nischeHtml
        ? '<div class="hm-app__leiste" role="list">' + nischeHtml + liste.map(function (e, n) {
          return karte('role="listitem" data-ersatz="' + n + '"', e.x.m, breiteText(e.x.m), e.diff == null ? '' : differenz(e.diff));
        }).join('') + '</div>'
        : '<p class="hm-app__klein">An dieser Stelle passt kein anderes Modell derselben Art.</p>');
      if (ohneFront) o.push(nischeTyp === 'kuehl'
        ? '<p class="hm-app__klein">Schon einen freistehenden Kühlschrank? „Eigener Kühlschrank“ lässt die Nische frei – ohne Hochschrank.</p>'
        : '<p class="hm-app__klein">Schon einen Geschirrspüler mit eigener Tür? „Eigener Geschirrspüler“ lässt die Nische frei – ohne Front.</p>');
      if (gr) {
        o.push('<div class="hm-app__chips hm-app__anschlag" role="group" aria-label="' + esc(K.gruppenName(g.m, gr.gruppe)) + '"><span class="hm-app__lab">' + esc(K.gruppenName(g.m, gr.gruppe)) + '</span>'
          + gr.werte.map(function (v) { return '<button type="button" class="hm-app__chip" data-wahl="' + esc(v) + '" aria-pressed="' + (jetzt === v) + '">' + esc(v) + '</button>'; }).join('') + '</div>');
      }
      /* Zwei Haengeschraenke uebereinander (Betreiber 2026-09-25): gleich breit, buendig darauf. */
      var stapel = /\|oben$/.test(g.key) && !K.istEck(g.m) ? K.stapelAngebot(z, daten, g.key + '|' + g.i) : [];
      if (stapel.length) {
        o.push('<span class="hm-app__lab">Darüber setzen</span>');
        o.push('<div class="hm-app__leiste" role="list">' + stapel.map(function (e, n) {
          return karte('role="listitem" data-stapel="' + n + '"', e.x.m, breiteText(e.x.m) + ' · ' + Math.round(e.x.m.h) + ' cm hoch', K.eur(e.x.v.preis));
        }).join('') + '</div>');
      }
      o.push('<div class="hm-app__aktionen">'
        + (K.istEck(g.m) ? '' : ['-1', '1'].map(function (dd) {
          /* Der Kern entscheidet, ob es geht (Nachbar an der Wand, kein neuer Fehler); gesperrt
             zeigt der Knopf den Grund beim Darueberfahren. */
          var rs = K.schieben(z, daten, g.key + '|' + g.i, +dd);
          var aus = rs.sperre || rs.fehler;
          return '<button type="button" class="hm-app__chip" data-schieben="' + dd + '"' + (aus ? ' disabled title="' + esc(aus) + '"' : '')
            + ' aria-label="Nach ' + (dd === '1' ? 'rechts' : 'links') + ' verschieben">' + (dd === '1' ? '→' : '←') + '</button>';
        }).join(''))
        + '<button type="button" class="hm-app__chip hm-app__chip--weg" data-entfernen>Entfernen</button></div>');
      box.innerHTML = o.join('');
      lageBinden(box);
      box.querySelectorAll('[data-ersatz]').forEach(function (b) {
        b.addEventListener('click', function () {
          var e = liste[+b.getAttribute('data-ersatz')];
          /* Aus der Geschirrspuelerfront (dem Kuehlumbau) wird etwas anderes: die Ausstattung soll es wissen. */
          if (g.m.funktion === 'geschirrspuelerfront') {
            (z.wunsch = z.wunsch || {}).gs = e.x.m.funktion === 'geschirrspuelerfront' ? (e.x.m.h < 65 ? 'teil' : 'voll') : 'keiner';
          }
          if (g.m.funktion === 'kuehlumbau') (z.wunsch = z.wunsch || {}).kuehl = e.x.m.funktion === 'kuehlumbau' ? 'einbau' : 'keiner';
          uebernehmen(e.r);
          /* Wird ein Hochschrank daraus, gehen die Haengeschraenke an seiner Stelle mit — das sagen. */
          var mit = e.r.mitEntfernt && e.r.mitEntfernt.length;
          sagen(kurzName(e.x.m) + ' ' + breiteText(e.x.m) + ' eingesetzt' + (mit
            ? (mit === 1 ? ' – der Hängeschrank an dieser Stelle wurde entfernt.' : ' – die Hängeschränke an dieser Stelle wurden entfernt.') : '.'));
          kuecheZeigen();
        });
      });
      var ofk = box.querySelector('[data-ohnefront]');
      if (ofk) ofk.addEventListener('click', function () {
        var r = K.stellplatzStatt(z, daten, g.key + '|' + g.i);
        if (r.fehler || r.sperre) { sagen(r.fehler || r.sperre); return; }
        r.sel = 'stell|' + r.id;
        (z.wunsch = z.wunsch || {})[nischeTyp === 'kuehl' ? 'kuehl' : 'gs'] = 'eigen';
        uebernehmen(r);
        sagen(nischeTyp === 'kuehl'
          ? 'Eigener Kühlschrank: ' + breiteText(g.m) + ' Nische ohne Schrank eingeplant – der Hochschrank ist nicht mehr in der Summe.'
          : 'Eigener Geschirrspüler: ' + breiteText(g.m) + ' Nische ohne Front eingeplant – die Front ist nicht mehr in der Summe.');
        kuecheZeigen();
      });
      box.querySelectorAll('[data-stapel]').forEach(function (b) {
        b.addEventListener('click', function () {
          var e = stapel[+b.getAttribute('data-stapel')];
          uebernehmen(e.r);
          sagen(kurzName(e.x.m) + ' ' + breiteText(e.x.m) + ' darübergesetzt.');
          kuecheZeigen();
        });
      });
      box.querySelectorAll('[data-wahl]').forEach(function (b) {
        b.addEventListener('click', function () {
          rueckMerken();
          var wa = K.wahlListe(z, g.key); wa[g.i] = b.getAttribute('data-wahl');
          z.wahl[g.key] = wa; inselAbgleichen(g.wand); merken();
          sagen(kurzName(g.m) + ': ' + b.textContent.trim() + ' gewählt.');
          kuecheZeigen();
        });
      });
      box.querySelectorAll('[data-schieben]').forEach(function (b) {
        b.addEventListener('click', function () { schieben(g, +b.getAttribute('data-schieben')); });
      });
      box.querySelector('[data-entfernen]').addEventListener('click', function () { entfernen(g); });
    } else if (blattModus === 'hinzu') {
      var reihen = HINZU_REIHEN.filter(function (r) { return !aufBlock() || r.k === 'unten'; });
      if (!reihen.some(function (r) { return r.k === hinzuReihe; })) hinzuReihe = 'unten';
      var hl = hinzuListe(hinzuReihe);
      o.push('<div class="hm-app__blattkopf"><div><b>Schrank hinzufügen</b><span>' + esc(wandName(z.wand)) + '</span></div>'
        + '<button type="button" class="hm-app__chip" data-blatt="fertig">Fertig</button></div>');
      o.push('<div class="hm-app__chips" role="group" aria-label="Art">' + reihen.map(function (r) {
        return '<button type="button" class="hm-app__chip" data-hinzureihe="' + r.k + '" aria-pressed="' + (hinzuReihe === r.k) + '">' + r.t + '</button>';
      }).join('') + '</div>');
      o.push(hl.length
        ? '<div class="hm-app__leiste" role="list">' + hl.map(function (e, n) {
          return karte('role="listitem" data-hinzu="' + n + '"', e.x.m, breiteText(e.x.m), K.eur(e.x.v.preis), e.eben ? 'Eben entfernt' : '');
        }).join('') + '</div>'
        : '<p class="hm-app__klein">Für diese Art ist an dieser Wand kein Platz mehr.</p>');
      var eh = eckHinweis(hinzuReihe, hl);
      if (eh) o.push('<p class="hm-app__klein">' + esc(eh) + '</p>');
      box.innerHTML = o.join('');
      box.querySelectorAll('[data-hinzureihe]').forEach(function (b) {
        b.addEventListener('click', function () { hinzuReihe = b.getAttribute('data-hinzureihe'); blattZeigen(); });
      });
      box.querySelectorAll('[data-hinzu]').forEach(function (b) {
        b.addEventListener('click', function () {
          var e = hl[+b.getAttribute('data-hinzu')];
          if (e.eben) delete zuletztWeg[z.wand];
          uebernehmen(e.r);
          blattModus = 'auswahl';
          sagen(kurzName(e.x.m) + ' ' + breiteText(e.x.m) + ' hinzugefügt.');
          kuecheZeigen();
        });
      });
    } else {
      var alle = [];
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        K.items(z, daten, z.wand, zl).forEach(function (it) { alle.push({ zl: zl, it: it }); });
      });
      alle.sort(function (a, b) { return a.it.x - b.it.x || (a.zl === 'boden' ? -1 : 1); });
      var offenT = alle.length ? offeneTexte() : [];
      o.push('<p class="hm-app__blatttext">' + (alle.length
        ? (offenT.length ? 'Vor der Bestellung ' + (offenT.length === 1 ? 'ist noch ein Punkt offen' : 'sind noch ' + offenT.length + ' Punkte offen')
          + ' – siehe Planungs-Check. Tippen Sie einen Schrank an, um ihn zu ändern.'
          : 'Ihre Küche ist fertig geplant. Tippen Sie einen Schrank an, um ihn zu ändern.')
        : 'An dieser Wand steht noch kein Schrank.') + '</p>');
      /* Stufe 2: fand der Planer mit Fenster, Tür und Wasseranschluss keine Küche, sagt es der Kunde nicht selbst. */
      if (!K.anzahl(z, daten) && K.aktiveMerkmale(z).some(function (m) { return /^(fenster|tuer|wasser|abfluss)$/.test(m.typ); })) {
        o.push('<p class="hm-app__hinweis" role="note">Mit diesen Angaben zu Fenster, Tür und Wasseranschluss passt keine Küche – meist '
          + 'ist am Wasseranschluss zu wenig Platz für den Spülenschrank (Ecke oder Tür daneben). Prüfen Sie die Stellen im Raum oder setzen Sie die Schränke selbst.'
          + ' <button type="button" class="hm-app__chip" data-app-zumraum>Raum prüfen</button></p>');
      }
      o.push(kuehlHinweis());
      o.push(gsHinweis());
      o.push(checkKarte());
      /* PDF zum Mitnehmen (Betreiber 2026-09-26): sichtbar im Kuechenbildschirm, nicht erst am Ende der
         Zusammenfassung — und als Datei, nicht ueber den Druckdialog. */
      if (w.HMPlanerPdf && w.HMPlanerBeleg && K.anzahl(z, daten)) {
        o.push('<div class="hm-app__chips hm-app__pdfzeile">' + pdfKnopf('0', 'Planung als PDF') + pdfKnopf('1', 'PDF ohne Preise') + '</div>');
      }
      /* Platte und Sockel VOR den Schrankstreifen (UX 2026-09-27): auf dem Telefon lagen sie drei
         Bildschirmhoehen tiefer, und die Streifen wiederholen nur, was die Ansicht darueber schon
         zeigt. Was der Kunde noch ergaenzen kann, steht jetzt dort, wo er hinsieht. */
      o.push(platteKarte());
      o.push(sockelKarte());
      /* Dieselben Schraenke wie in der Zeichnung, als Bildstreifen — je Reihe, in der Reihenfolge
         an der Wand: Produktbild, Name, Breite. Antippen waehlt wie in der Zeichnung; mit der
         Tastatur und fuer schmale Schraenke der sichere Weg. */
      /* Ueberschriften wie im Markt: Unterschraenke (mit Hochschraenken, wenn welche dastehen), Haengeschraenke,
         Aufsatzschraenke. */
      var mitHoch = alle.some(function (e) { return e.zl === 'boden' && e.it.m && e.it.m.reihe === 'voll'; });
      [['boden', mitHoch ? 'Unter- & Hochschränke' : 'Unterschränke'], ['oben', 'Hängeschränke'], ['aufsatz', 'Aufsatzschränke']].forEach(function (r) {
        var teil = alle.filter(function (e) { return e.zl === r[0]; });
        if (r[0] === 'boden') {
          teil = teil.concat(stellplaetze(z.wand).map(function (m) { return { zl: 'boden', nische: m, it: { x: m.x } }; }));
          teil.sort(function (a, b) { return a.it.x - b.it.x; });
        }
        if (!teil.length) return;
        o.push('<span class="hm-app__lab">' + r[1] + '</span><div class="hm-app__leiste hm-app__leiste--klein" role="list" aria-label="' + r[1] + '">'
          + teil.map(function (e) {
            if (e.nische) return nischenKarte('role="listitem" data-waehle="stell|' + e.nische.id + '"',
              K.r0(e.nische.breite) + ' cm · ' + (e.nische.typ === 'kuehl' ? 'ohne Schrank' : 'ohne Front'), '', e.nische.typ);
            return karte('role="listitem" data-waehle="' + z.wand + '|' + e.zl + '|' + e.it.i + '"', e.it.m, K.r0(e.it.b) + ' cm', '');
          }).join('') + '</div>');
      });
      if (platzFrei()) o.push('<button type="button" class="hm-app__chip hm-app__chip--plus" data-blatt="hinzu">+ Schrank hinzufügen</button>');
      box.innerHTML = o.join('');
      pdfKnoepfeBinden(box);
      checkKnoepfeBinden(box);
      box.querySelectorAll('[data-waehle]').forEach(function (b) {
        b.addEventListener('click', function () { waehlen(b.getAttribute('data-waehle')); });
      });
      box.querySelectorAll('[data-sockel]').forEach(function (b) {
        b.addEventListener('click', function () { sockelSetzen(b.getAttribute('data-sockel') === 'an'); });
      });
      box.querySelectorAll('[data-platte]').forEach(function (b) {
        b.addEventListener('click', function () { platteSetzen(b.getAttribute('data-platte') || null); });
      });
    }
    box.querySelectorAll('[data-blatt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ziel = b.getAttribute('data-blatt');
        if (ziel === 'fertig') { z.sel = null; blattModus = 'ueberblick'; }
        else blattModus = ziel;
        kuecheZeigen();
      });
    });
  }

  /* ---------- Der Sockel ----------

     Betreiber 2026-09-24: „der Sockel wurde weder gesetzt noch dem Kunden gesagt". Jede Serie hat
     ein Sockelprogramm im Katalog, und der Kern rechnet den Bedarf (Front + offene Seiten,
     sockelBedarf/sockelEnden). Hier wird daraus EIN Vorschlag: so viele 2-m- und 1-m-Leisten und
     Abschluesse, wie diese Kueche braucht — das guenstigere von „ein 2-m-Stueck mehr" und
     „1-m-Stuecke fuer den Rest". Bei jeder Planaenderung neu berechnet.
     STANDARDMAESSIG DABEI (Betreiber 2026-09-27: „الزوكيل لازم ان يكون افتراضي مضاف"). Bis hierher angeboten und nicht
     vorausgewaehlt (§ 312a Abs. 3 BGB: kein voreingestellter kostenpflichtiger ZUSATZ). Seit der Betreiber die Leiste zur
     Pflicht gemacht hat (ohne sie keine Kasse, siehe sockelFehlt), ist sie kein waehlbarer Zusatz mehr, sondern Teil der
     Kueche — sie steht mit Preis in der Summe, in der Zusammenfassung und im Beleg. Entfernen bleibt moeglich (Marke „0"
     im Speicher, bleibt ueber das Neuladen), sperrt dann aber wie bisher die Kasse. Die Arbeitsplatte bleibt eine echte
     Wahl und darum NICHT vorausgewaehlt. */
  var SOCKEL_MARKE = 'hmk-app-sockel', sockelOhneSpeicher = null;
  function sockelAn(wert) {
    if (wert === undefined) {
      try { return w.localStorage.getItem(SOCKEL_MARKE) !== '0'; } catch (e) { return sockelOhneSpeicher !== false; }
    }
    sockelOhneSpeicher = !!wert;
    try { w.localStorage.setItem(SOCKEL_MARKE, wert ? '1' : '0'); } catch (e) { /* ohne Speicher: nur fuer diese Seite */ }
    return !!wert;
  }
  /* (zz, dd): fuer die laufende Kueche ohne Angaben; der Stil-Schirm rechnet damit die Preise der Startkuechen. */
  function sockelPaket(zz, dd) {
    zz = zz || z; dd = dd || daten;
    if (!dd || !K.anzahl(zz, dd)) return null;
    var arten = K.zubehoerArten(zz, dd), da = {};
    arten.forEach(function (a) { da[a.id] = a; });
    if (!da.sl200 && !da.sl100) return null;
    var bedarf = K.sockelBedarf(zz, dd), enden = K.sockelEnden(zz, dd);
    var mitZ = function (pk) { var t = {}; for (var k in zz) { if (Object.prototype.hasOwnProperty.call(zz, k)) t[k] = zz[k]; } t.zubehoer = pk; return t; };
    var bauen = function (extra200) {
      var pk = {}, n200 = da.sl200 ? Math.floor(bedarf / 200) + (extra200 ? 1 : 0) : 0;
      var rest = Math.max(0, bedarf - n200 * 200);
      if (n200) pk.sl200 = n200;
      if (rest > 0) { if (da.sl100) pk.sl100 = Math.ceil(rest / 100); else if (da.sl200) pk.sl200 = (pk.sl200 || 0) + Math.ceil(rest / 200); }
      if (da.sab && enden.enden) pk.sab = enden.enden;
      if (da.sabt && enden.tief) pk.sabt = enden.tief;
      return pk;
    };
    var a = bauen(false), b = da.sl200 && da.sl100 ? bauen(true) : null;
    var pk = (b && K.zubehoerSumme(mitZ(b), dd) < K.zubehoerSumme(mitZ(a), dd)) ? b : a;
    return { zubehoer: pk, summe: K.zubehoerSumme(mitZ(pk), dd), bedarf: bedarf, stuecke: enden.stirnseiten };
  }
  function sockelNachfuehren() {
    if (!sockelAn() || !daten) return;
    var p = sockelPaket();
    var neu = p ? p.zubehoer : {};
    if (JSON.stringify(neu) !== JSON.stringify(z.zubehoer || {})) { z.zubehoer = neu; merken(); }
  }
  function sockelSetzen(an) {
    rueckMerken();
    sockelAn(an);
    if (an) sockelNachfuehren(); else { z.zubehoer = {}; merken(); }
    sagen(an ? 'Sockelleiste hinzugefügt.' : 'Sockelleiste entfernt.');
    kuecheZeigen();
  }
  /* PFLICHT (Betreiber 2026-09-27: „يجب ان يضاف الزوكيل بشكل اجباري يعني لايمكن الذهاب للكاسة بدون اضافة زوكيل"): ohne
     Sockelleiste keine Kasse. Seit dem Nachtrag desselben Tages ist sie von Anfang an dabei (siehe oben); gesperrt wird nur,
     wenn der Kunde sie entfernt hat — dann nennt „Zur Kasse" den Grund. Nur wo die Serie ein Sockelprogramm hat. */
  var SOCKEL_FEHLT = 'Die Sockelleiste fehlt noch – bitte unter „Sockelleiste“ hinzufügen.';
  function sockelFehlt() {
    return !!daten && !!sockelPaket() && !(sockelAn() && Object.keys(z.zubehoer || {}).length);
  }
  function sockelKarte() {
    var p = sockelPaket();
    if (!p) return '';
    var an = sockelAn() && Object.keys(z.zubehoer || {}).length;
    var meter = String(Math.round(p.bedarf) / 100).replace('.', ',');
    return '<div class="hm-app__sockel' + (an ? ' is-an' : ' is-pflicht') + '" data-app-sockelkarte>'
      + '<div><b>Sockelleiste</b><span>' + (an
        ? 'Hinzugefügt · ' + esc(meter) + ' m für Ihre Küche · ' + esc(K.eur(p.summe))
        : 'Die Blende unter den Schränken. Ihre Küche braucht ' + esc(meter) + ' m · ' + esc(K.eur(p.summe))) + '</span></div>'
      + '<button type="button" class="hm-app__chip' + (an ? '' : ' hm-app__chip--plus') + '" data-sockel="' + (an ? 'aus' : 'an') + '">'
      + (an ? 'Entfernen' : 'Hinzufügen') + '</button></div>'
      + (an ? '' : '<p class="hm-app__klein hm-app__pflicht">Gehört zu jeder Küche: ohne Sockelleiste geht es nicht zur Kasse.</p>');
  }

  /* ---------- Die Arbeitsplatte (S3, 2026-09-26) ----------

     Neun Platten aus dem Shop, je auf Mass zugeschnitten. Der Kern rechnet die Stuecke
     (K.plattenStuecke: Ecken, Hochschraenke, ueber 400 cm geteilt) und je Stueck das Band und
     den Preis. Angeboten wird jede Platte mit dem Preis FUER DIESE KUECHE — nicht mit dem
     Einzelpreis eines Bandes, den der Kunde nicht umrechnen kann. Wie der Sockel NICHT
     vorausgewaehlt (§ 312a Abs. 3 BGB). */
  function plattenListe() {
    var tab = daten && K.plattenTabelle(daten);
    if (!tab || !K.anzahl(z, daten)) return [];
    return tab.map(function (p) {
      var zp = {}; for (var k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) zp[k] = z[k]; }
      zp.platte = p.id;
      var pos = K.arbeitsplattenPos(zp, daten);
      return { p: p, stuecke: pos.length, summe: pos.reduce(function (a, x) { return a + x.betrag; }, 0) };
    }).filter(function (e) { return e.stuecke > 0; });
  }
  /* Die zuletzt entfernte Platte: ihr Knopf wird „Hinzufügen" (Betreiber 2026-09-27: „خيار ازالة سطح العمل يجب ان يعود
     اضافة بدل القائمة العائمة") — wie beim Sockel, statt der schwebenden Leiste. */
  var platteZuletzt = null;
  function platteSetzen(id) {
    rueckMerken();
    if (!id && z.platte) platteZuletzt = z.platte;
    z.platte = id || null;
    merken();
    var p = K.platteVon(z, daten);
    sagen(p ? 'Arbeitsplatte ' + p.name + ' gewählt.' : 'Ohne Arbeitsplatte.');
    kuecheZeigen();
  }
  function platteKarte() {
    var liste = plattenListe();
    if (!liste.length) return '';
    var gew = K.platteVon(z, daten);
    var pos = gew ? K.arbeitsplattenPos(z, daten) : [];
    var laengen = (gew ? pos : K.plattenStuecke(z, daten)).map(function (s) { return s.laenge + ' cm'; }).join(' + ');
    var kopf = gew
      ? 'Gewählt · ' + esc(gew.name) + ' ' + gew.dicke + ' mm · ' + esc(laengen) + ' · ' + esc(K.eur(K.plattenSumme(z, daten)))
      : 'Aus dem Shop, auf Maß zugeschnitten. Ihre Küche braucht ' + esc(laengen) + '.';
    return '<div class="hm-app__sockel hm-app__platte' + (gew ? ' is-an' : '') + '">'
      + '<div><b>Arbeitsplatte</b><span>' + kopf + '</span></div>'
      + (gew ? '<button type="button" class="hm-app__chip" data-platte="">Entfernen</button>'
        : (platteZuletzt && liste.some(function (e) { return e.p.id === platteZuletzt; })
          ? '<button type="button" class="hm-app__chip hm-app__chip--plus" data-platte="' + esc(platteZuletzt) + '">Hinzufügen</button>' : '')) + '</div>'
      + '<div class="hm-app__leiste hm-app__leiste--klein" role="list" aria-label="Arbeitsplatten">'
      + liste.map(function (e) {
        var an = gew && gew.id === e.p.id;
        return '<button type="button" class="hm-app__modell" role="listitem" data-platte="' + esc(e.p.id) + '" aria-pressed="' + !!an + '">'
          + (e.p.img ? '<img src="' + esc(e.p.img) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="hm-app__modellbild"></span>')
          + '<b>' + esc(e.p.name) + '</b><span>' + e.p.dicke + ' mm</span>'
          + '<span class="hm-app__modellpreis">' + esc(K.eur(e.summe)) + '</span></button>';
      }).join('') + '</div>'
      + (gew ? '<p class="hm-app__klein">Wird auf die Maße Ihrer Planung zugeschnitten.</p>'
        : '<p class="hm-app__klein">Ohne Arbeitsplatte planen Sie nur die Schränke.</p>')
      /* Die Doppelinsel ist in keiner Laenge oben enthalten — der Kunde soll das nicht erraten. */
      + (K.inselOhnePlatte(z) ? '<p class="hm-app__klein hm-app__inselhinweis">' + esc(K.INSEL_OHNE_PLATTE) + '</p>' : '');
  }

  function waehlen(sel) {
    if (/^stell\|/.test(String(sel || ''))) {
      var mk = stellplaetze().filter(function (m) { return 'stell|' + m.id === sel; })[0];
      if (!mk) return;
      if (mk.wand !== z.wand) z.wand = mk.wand;
    }
    z.sel = (z.sel === sel && blattModus === 'auswahl') ? null : sel;
    blattModus = z.sel ? 'auswahl' : 'ueberblick';
    kuecheZeigen();
    var b = $('[data-app-blatt]');
    if (b) b.scrollTop = 0;
  }

  /* ← → tauscht den Schrank mit seinem Nachbarn IN DER REIHE — wie im alten Planer: getauscht
     werden die Schraenke, nicht ihre gezogenen Wandstellen. */
  /* ← → ueber den Kern (K.schieben): Nachbar AN DER WAND, ein Stapel wandert als Ganzes, und
     was einen neuen Fehler braechte, wird abgelehnt. Vorher tauschte die App zwei Eintraege der
     Planliste und liess die festen Stellen stehen — so kam ein G60 hinter das nutzbare Ende und
     ein hoher Schrank unter einen gestapelten (Betreiber 2026-09-27). */
  function schieben(g, d) {
    var r = K.schieben(z, daten, g.key + '|' + g.i, d);
    if (r.sperre || r.fehler) { sagen(r.sperre || r.fehler); return; }
    uebernehmen(r);
    sagen(kurzName(g.m) + ' nach ' + (d > 0 ? 'rechts' : 'links') + ' verschoben.');
    kuecheZeigen();
  }
  /* Ueber den Kern: faellt ein Unterschrank weg, geht der Haengeschrank genau darueber mit, und
     die uebrigen ruecken nach (K.entfernen / K.obenNachziehen). */
  function entfernen(g) {
    var r = K.entfernen(z, daten, g.key + '|' + g.i);
    if (r.fehler) { sagen(r.fehler); return; }
    rueckMerken();
    z.plan = r.plan; z.hoff = r.hoff; z.xpos = r.xpos; z.wahl = r.wahl;
    inselAbgleichen(g.wand);
    /* Fuer „Schrank hinzufügen": dieser Schrank zuerst, in seiner Art (siehe zuletztWeg). */
    zuletztWeg[g.wand] = g.mi;
    hinzuReihe = g.m.reihe === 'voll' ? 'voll' : g.m.reihe === 'unten' ? 'unten' : 'oben';
    /* Ging drueben derselbe Schrank mit, reicht „auf beiden Inselseiten"; beim Namen genannt wird
       nur ein anderer (die Spuele gegenueber). */
    if (inselGespiegelt && inselGespiegelt.every(function (n) { return n === kurzName(g.m); })) inselGespiegelt = [];
    z.sel = null; blattModus = 'ueberblick';
    var nMit = (r.mitEntfernt || []).length;
    sagen(kurzName(g.m) + ' entfernt' + (nMit > 1 ? ' – die ' + nMit + ' Hängeschränke darüber ebenfalls.'
      : (nMit ? ' – der Hängeschrank darüber ebenfalls.' : '.')));
    merken(); kuecheZeigen();
  }

  /* Eine Zeile fuer Bildschirmleser: was eben geschah. */
  function sagen(t) {
    if (inselGespiegelt && t) {
      t = t.replace(/\.$/, '') + (inselGespiegelt.length
        ? ' — auf der anderen Inselseite ebenfalls: ' + inselGespiegelt.join(', ') + '.'
        : ' — auf beiden Inselseiten.');
    }
    inselGespiegelt = null;
    var r = $('[data-app-ruf]'); if (r) { r.textContent = ''; r.textContent = t || ''; }
    if (rueckNeu) { rueckNeu = false; rueckZeigen(t); }
  }

  /* ---------- Rueckgaengig (UX 2026-09-27) ----------
     Jede Aenderung an der Kueche — Ersetzen, Hinzufuegen, Darueber setzen, Verschieben,
     Entfernen, Ausfuehrung, Sockel, Platte — laesst sich mit einem Tipp zuruecknehmen. Ein
     Kunde, der sich vertippt, soll nicht nachbauen muessen, was eben noch da war. Der Stapel
     gilt nur fuer denselben Raum und dieselbe Serie: nach neuen Massen oder einer anderen Serie
     passte ein alter Plan nicht mehr (dafuer gibt es „Vorherige Küche wiederherstellen"). */
  var RUECK = [], rueckNeu = false, rueckAktion = null;
  function rueckRahmen() {
    return JSON.stringify([z.serie, z.farbe].concat(RAUM_FELDER.filter(function (f) { return f !== 'wand'; }).map(function (f) { return z[f]; })));
  }
  function rueckMerken() {
    RUECK.push(JSON.stringify({ rahmen: rueckRahmen(), plan: z.plan, hoff: z.hoff, xpos: z.xpos, wahl: z.wahl,
      platte: z.platte || null, zubehoer: z.zubehoer || {}, sockel: sockelAn(), wand: z.wand,
      merkmale: z.merkmale || [], mid: z.mid || 1 }));
    if (RUECK.length > 30) RUECK.shift();
    rueckNeu = true;
    if (rueckAktion) { if (rueckAktion === vorherHolen) vorherSchreiben(null); rueckAktion = null; }
  }
  /* `aktion`: was „Rückgängig" tut, wenn es nicht der Stapel ist (die neue Kueche nach neuen Massen). Bis 2026-09-27 eine
     schwebende Leiste mit Text, die nach 7 s verschwand; jetzt der feste Knopf in der Ansicht (undoZeigen). Der Text
     geht an die Vorlesezeile (sagen). Die Sonderaktion gilt bis zur naechsten Aenderung oder bis der Kunde die Kueche
     verlaesst. */
  function rueckZeigen(t, aktion) {
    if (schirm !== 'kueche') return;
    if (rueckAktion && rueckAktion !== aktion) vorherSchreiben(null);
    rueckAktion = aktion || null;
    undoZeigen();
  }
  function rueckWeg() {
    /* Der Rueckweg zur alten Kueche gilt nur, solange er angeboten wird — sonst tauchte er Tage
       spaeter wieder auf, fuer eine Aenderung, an die sich niemand mehr erinnert. */
    if (rueckAktion === vorherHolen) vorherSchreiben(null);
    rueckAktion = null;
    undoZeigen();
  }
  function undoMoeglich() {
    if (rueckAktion) return true;
    if (!RUECK.length) return false;
    try { return JSON.parse(RUECK[RUECK.length - 1]).rahmen === rueckRahmen(); } catch (e) { return false; }
  }
  function undoZeigen() {
    var b = $('[data-app-undo]');
    if (!b) return;
    var geht = schirm === 'kueche' && undoMoeglich();
    b.disabled = !geht;
    b.setAttribute('aria-label', geht ? 'Rückgängig' : 'Rückgängig – nichts zurückzunehmen');
  }
  function rueckKnopf() {
    var a = rueckAktion;
    if (a) { rueckAktion = null; rueckWeg(); a(); } else rueckgaengig();
  }
  function rueckgaengig() {
    var s = RUECK.pop();
    zuletztWeg = {};
    rueckWeg();
    if (!s) { undoZeigen(); return; }
    s = JSON.parse(s);
    if (s.rahmen !== rueckRahmen()) { RUECK = []; undoZeigen(); return; }
    z.plan = s.plan; z.hoff = s.hoff; z.xpos = s.xpos; z.wahl = s.wahl;
    z.platte = s.platte; z.zubehoer = s.zubehoer; sockelAn(s.sockel);
    if (s.merkmale) { z.merkmale = s.merkmale; z.mid = s.mid || z.mid; }
    if (s.wand) z.wand = s.wand;
    z.sel = null; blattModus = 'ueberblick';
    merken();
    sagen('Rückgängig gemacht.');
    kuecheZeigen();
  }

  /* Rueckgaengig (Betreiber 2026-09-27: „يجب تغيير مكان زر التراجع ياخذ مكان كبير"): bis hierher ein Knopf mit Wort links
     oben IN der Ansicht — er deckte Zeichnung und 3D zu. Jetzt ein Symbolknopf in der Kopfzeile, neben 2D/3D; sein Name
     steht fuer Bildschirmleser und als Hinweis im Titel. Grau, solange es nichts zurueckzunehmen gibt (undoZeigen). */
  var UNDO_KNOPF = '<button type="button" class="hm-app__chip hm-app__undo" data-app-undo disabled title="Rückgängig" aria-label="Rückgängig">'
    + '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg></button>';
  function wandChipsZeigen() {
    var box = $('[data-app-waende]'), ws = schrankWaende();
    box.hidden = false;
    /* GANZE KUECHE (Betreiber 2026-09-29: „لا استطيع رؤية جميع الخزائن معنا"): nach einer Wandansicht gab es keinen Weg zurueck
       zur ganzen Kueche. In 3D steht er vor den Waenden; gedrueckt ist, was die Ansicht zeigt. */
    var ganz = ansichtDrei && CFG.dreiD !== false && !!w.HMKonfig3D;
    box.innerHTML = (ws.length > 1 || ganz ? '<div class="hm-app__wandwahl" role="group" aria-label="Ansicht">'
      + (ganz ? '<button type="button" class="hm-app__chip" data-raumblick aria-pressed="' + (dreiBlick === 'raum') + '">Ganze Küche</button>' : '')
      + (ws.length > 1 ? ws.map(function (id) {
        var an = ganz ? dreiBlick === 'wand' && z.wand === id : z.wand === id;
        return '<button type="button" class="hm-app__chip" data-wandwahl="' + id + '" aria-pressed="' + an + '">' + esc(wandName(id)) + '</button>';
      }).join('') : '') + '</div>' : '<span></span>')
      + '<div class="hm-app__werkzeuge">' + UNDO_KNOPF
      + (CFG.dreiD !== false && w.HMKonfig3D ? '<div class="hm-app__vw" role="group" aria-label="Ansicht">'
        + ['2D', '3D'].map(function (a) { return '<button type="button" class="hm-app__chip" data-vw="' + a + '" aria-pressed="' + ((a === '3D') === ansichtDrei) + '">' + a + '</button>'; }).join('') + '</div>' : '')
      + '</div>';
    box.querySelector('[data-app-undo]').addEventListener('click', rueckKnopf);
    undoZeigen();
    /* Einzeilige Wandreihe: laeuft sie ueber, blendet der Rand aus, und die gewaehlte Wand steht im Bild. */
    var ww = box.querySelector('.hm-app__wandwahl');
    if (ww) {
      var mehr = function () { ww.classList.toggle('is-mehr', ww.scrollLeft + ww.clientWidth < ww.scrollWidth - 1); };
      var akt = ww.querySelector('[aria-pressed="true"]');
      if (akt && akt.offsetLeft + akt.offsetWidth > ww.clientWidth) ww.scrollLeft = akt.offsetLeft - 8;
      ww.addEventListener('scroll', mehr, { passive: true });
      mehr();
    }
    /* Der Wandknopf wechselt auch das BILD (Betreiber 2026-09-28: „ازرار Hauptwand Seitenwand لاتحول المشهد"). In 2D
       zeigte die Zeichnung schon die gewaehlte Wand; in 3D blieb die Kamera stehen, wo sie war — der Knopf wurde gruen,
       und sonst geschah nichts. Jetzt blickt 3D von vorn auf genau diese Wand (die Frontansicht des 3D-Moduls). Auch
       ein Tipp auf die schon gewaehlte Wand holt sie wieder ins Bild. */
    box.querySelectorAll('[data-raumblick]').forEach(function (b) {
      b.addEventListener('click', function () {
        dreiBlick = 'raum';
        if (w.HMKonfig3D) w.HMKonfig3D.blick('raum', z.wand);
        wandChipsZeigen();
      });
    });
    box.querySelectorAll('[data-wandwahl]').forEach(function (b) {
      b.addEventListener('click', function () {
        z.wand = b.getAttribute('data-wandwahl'); z.sel = null; blattModus = 'ueberblick';
        wandBlickOffen = true;
        merken(); kuecheZeigen();
      });
    });
    box.querySelectorAll('[data-vw]').forEach(function (b) {
      b.addEventListener('click', function () { ansichtDrei = b.getAttribute('data-vw') === '3D'; ansichtMerken(); kuecheZeigen(); });
    });
  }

  function kuecheZeigen() {
    var box = $('[data-app-kueche]');
    if (!daten) { box.innerHTML = '<p class="hm-app__hinweis" role="status">Katalog wird geladen …</p>'; return; }
    if (!box.querySelector('[data-app-front]')) {
      box.innerHTML = '<div class="hm-app__kopfzeile" data-app-waende></div>'
        + '<div class="hm-app__ansicht"><div class="hm-app__front" data-app-front></div>'
        + '<div class="hm-app__drei" data-app-drei hidden><p class="hm-app__klein" data-app-dreimeldung></p>'
        /* Foto-Modus (S4): dieselbe Szene per Pfadverfolgung — Licht, Schatten, Spiegelungen. */
        + '<div class="hm-app__foto" data-app-foto><button type="button" class="hm-app__chip" data-foto>Foto</button>'
        /* Ein Knopf, kein blauer Link (Betreiber 2026-09-28): gefuellt in der Shopfarbe, mit Pfeil nach unten. */
        + '<a class="hm-app__chip hm-app__speichern" data-foto-speichern hidden download="hi-markt-kueche.jpg">'
        + '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">'
        + '<path d="M12 4v11M7 10l5 5 5-5M5 20h14"/></svg><span>Bild speichern</span></a></div></div></div>'
        + '<div class="hm-app__blatt" data-app-blatt></div>'
        + '<p class="hm-app__sr" data-app-ruf aria-live="polite"></p>';
      $('[data-app-front]').addEventListener('click', function (e) {
        var g = e.target.closest && e.target.closest('[data-sel]');
        if (g) { waehlen(g.getAttribute('data-sel')); return; }
        /* Die Nische des eigenen Geschirrspuelers (im Kern `data-mk`). */
        var mkEl = e.target.closest && e.target.closest('[data-mk]');
        var mk = mkEl && stellplaetze().filter(function (m) { return String(m.id) === mkEl.getAttribute('data-mk'); })[0];
        if (mk) waehlen('stell|' + mk.id);
      });
    }
    if (schrankWaende().indexOf(z.wand) < 0) z.wand = schrankWaende()[0] || 'A';
    sockelNachfuehren();
    wandChipsZeigen();
    zeichnungZeigen();
    blattZeigen();
    fussZeigen();
    undoZeigen();
  }

  /* ---------- Kasse ----------

     Derselbe Weg wie im alten Planer (zurKasse): die Planung geht an den Bestell-Dienst, der
     sie mit DEMSELBEN Kern prueft, und erst seine Antwort nennt die Adresse der Kasse. Kein
     stiller Rueckfall in den normalen Warenkorb — dort gaebe es den Planungsrabatt nicht. */
  var PROXY = '/apps/kuechenplaner';
  var DEV = !!(w.Shopify && w.Shopify.theme && w.Shopify.theme.role && w.Shopify.theme.role !== 'main');
  var KAUF_STANDARD = 'Der Checkout für Ihre Küchenplanung konnte gerade nicht erstellt '
    + 'werden. Ihre Planung bleibt gespeichert. Bitte versuchen Sie es erneut.';
  var KAUF_TEXTE = {
    PLAN_INVALID:      'Ihre Planung ist noch nicht vollständig. Bitte klären Sie zuerst die offenen Punkte.',
    INVALID_PRODUCT:   'Ein Schrank aus Ihrer Planung ist gerade nicht verfügbar. Bitte prüfen Sie die Planung.',
    PLAN_EXPIRED:      'Die Freigabe Ihrer Planung ist abgelaufen. Ihre Planung bleibt gespeichert — bitte versuchen Sie es erneut.',
    PLAN_NOT_FOUND:    'Die Freigabe Ihrer Planung wurde nicht gefunden. Ihre Planung bleibt gespeichert — bitte versuchen Sie es erneut.',
    PLAN_IN_PROGRESS:  'Der Checkout wird bereits vorbereitet. Einen Moment bitte.',
    RATE_LIMITED:      'Zu viele Versuche kurz hintereinander. Bitte einen Moment warten.'
  };
  var kaufLaeuft = false, kaufMeldung = null;
  function proxyPost(pfad, nutzlast) {
    return w.fetch(PROXY + pfad, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(nutzlast)
    }).then(function (r) {
      return r.text().then(function (t) {
        var d = null;
        try { d = JSON.parse(t); } catch (e) { d = null; }
        return { status: r.status, daten: d };
      });
    });
  }
  function kaufFehler(a) {
    var e = new Error('kauf');
    e.kaufCode = (a && a.daten && a.daten.code) || 'NETZ';
    return e;
  }
  function zurKasse() {
    if (!daten || !K.kaufbar(z, daten) || kaufLaeuft || sockelFehlt()) return;
    kaufLaeuft = true; kaufMeldung = null;
    fussZeigen();
    proxyPost('/plan', { zustand: K.planNutzlast(z, daten) }).then(function (a) {
      if (a.status !== 200 || !a.daten || !a.daten.ok || !a.daten.planning_id) throw kaufFehler(a);
      return proxyPost('/checkout', { planning_id: a.daten.planning_id });
    }).then(function (a) {
      if (a.status !== 200 || !a.daten || !a.daten.ok) throw kaufFehler(a);
      if (a.daten.checkout_url) { w.location.assign(a.daten.checkout_url); return; }
      kaufLaeuft = false;
      if (a.daten.mode === 'dry_run' && DEV) {
        kaufMeldung = 'DEV-Trockenlauf bestanden: Freigabe ' + a.daten.planning_id + ' · ' + a.daten.eligible_lines
          + ' rabattfähige Zeilen · ' + a.daten.would_apply_discount_percent + ' % vorgesehen. Es wurde KEIN Draft Order erzeugt.';
        fussZeigen();
        return;
      }
      throw kaufFehler(a);
    }).catch(function (e) {
      kaufLaeuft = false;
      if (w.console && w.console.warn) w.console.warn('[kuechenplaner]', (e && e.kaufCode) || e);
      kaufMeldung = KAUF_TEXTE[e && e.kaufCode] || KAUF_STANDARD;
      fussZeigen();
    });
  }

  /* PLANUNGSRABATT — 30 % seit 2026-09-27 (Betreiber: „اريد تغيير الخصم الى ٣٠ بالمئة وان يظهر هنا ايضا"; vorher
     20 % und nur als Satz „an der Kasse"). Der Preis NACH dem Rabatt steht jetzt hier, in der Zusammenfassung
     und in der PDF. Die Zahl muss mit RABATT_PROZENT im Bestell-Dienst uebereinstimmen (wrangler.toml); die
     Grenze ist ein REGULAERER Wert aus der Einstellung des Abschnitts (1.500 € = RABATT_MINDESTWERT 1.050
     nach 30 %). Gerechnet wird wie im Bestell-Dienst: rabattfaehig sind die Schraenke (Sammlung) und die
     Arbeitsplatten (seine Regel), das Zubehoer (Sockelleiste) nicht — und nur diese Zeilen zaehlen zur Grenze.
     Der Nachlass je Stueck wird abgeschnitten wie bei Shopify, nie gerundet: der Preis hier liegt nie unter
     dem der Kasse. Alles in Cent. */
  var RABATT_PROZENT = 30;
  function rabattRechnung() {
    var grenze = Number(CFG.rabattMindestRegulaer || 0);
    if (!daten || !(grenze > 0)) return null;
    var cent = function (x) { return Math.round(x * 100); };
    var stuecke = K.positionen(z, daten).map(function (p) { return [cent(p.v.preis), p.menge]; })
      .concat(K.arbeitsplattenPos(z, daten).filter(function (p) { return p.vid; }).map(function (p) { return [cent(p.preis), 1]; }));
    var basis = stuecke.reduce(function (a, s) { return a + s[0] * s[1]; }, 0);
    var erreicht = basis > 0 && basis >= cent(grenze);
    var nachlass = erreicht ? stuecke.reduce(function (a, s) { return a + s[1] * Math.floor(s[0] * RABATT_PROZENT / 100); }, 0) : 0;
    var gesamt = cent(K.gesamt(z, daten));
    return { prozent: RABATT_PROZENT, grenze: grenze, erreicht: erreicht && nachlass > 0,
      fehlt: Math.max(0, cent(grenze) - basis) / 100, nachlass: nachlass / 100, gesamt: gesamt / 100, preis: (gesamt - nachlass) / 100 };
  }
  function rabattZeile(r) {
    r = r || rabattRechnung();
    if (!r) return '';
    return r.erreicht ? 'inkl. ' + r.prozent + ' % Planungsrabatt: −' + K.eur(r.nachlass)
      : 'noch ' + K.eur(r.fehlt) + ' bis −' + r.prozent + ' % Planungsrabatt';
  }
  function rabattBedingung(r) {
    return 'Der Planungsrabatt gilt für die Schränke und Arbeitsplatten Ihrer Planung ab ' + K.eur(r.grenze)
      + ' Warenwert. Nicht mit anderen Rabattcodes kombinierbar. Verbindlich ist der Betrag an der Kasse.';
  }
  function offenePunkte() {
    return K.pruefung(z, daten).filter(function (m) { return m.art === 'fehler'; });
  }
  /* OFFENE PUNKTE IN JEDER ANZEIGE (Betreiber 2026-09-30): Kasse, Tafeltext und Planungs-Check lesen dieselbe Liste — die
     Fehler der Kernpruefung (dieselbe Rechnung wie K.kaufbar) und die fehlende Sockelleiste, in dieser Reihenfolge wie in
     fussZeigen. Bis hierher stand „fertig geplant" und „6 von 6 Punkten erfüllt" auch dann, wenn die Kasse gesperrt war —
     etwa nach dem Wechsel auf eine dickere Arbeitsplatte, die unter eine niedrige Fensterbank stoesst. Jede Anzeige rechnet
     bei jedem Neuzeichnen (auch nach platteSetzen) neu, gespeichert wird kein Ergebnis. */
  function offeneTexte() {
    if (!daten || !K.anzahl(z, daten)) return [];
    var t = offenePunkte().map(function (m) { return kundenText(m.text); });
    if (sockelFehlt()) t.push(SOCKEL_FEHLT);
    return t;
  }

  /* ---------- Planung als PDF-Datei (HMPlanerPdf) ---------- */

  var pdfLaeuft = false;
  function pdfKnopf(ohne, text) {
    return '<button type="button" class="hm-app__chip" data-pdf="' + ohne + '">'
      + '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">'
      + '<path d="M12 4v11M7 10l5 5 5-5M5 20h14"/></svg><span>' + text + '</span></button>';
  }
  /* Knopf im Planungs-Check (Betreiber 2026-09-26): „Backofen unter das Kochfeld" — dieselbe Antwort wie in der
     Ausstattung, danach eine neue Kueche. Die bisherige bleibt ueber „Rückgängig" erreichbar (auch eine
     unveraenderte Startkueche: der Kunde soll zurueck koennen, ohne die Frage zu suchen). */
  function checkKnoepfeBinden(box) {
    box.querySelectorAll('[data-app-zumraum]').forEach(function (b) {
      b.addEventListener('click', function () { geheZu('raum', 'push'); });
    });
    box.querySelectorAll('[data-check-aktion="ofen-unten"]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!daten) return;
        vorherSchreiben(K.planNutzlast(z, daten));
        (z.wunsch = z.wunsch || {}).ofen = 'unten';
        z.plan = {}; z.hoff = {}; z.xpos = {}; z.wahl = {}; z.sel = null;
        startMarke(false);
        geheZu('kueche', 'ersetzen');
      });
    });
  }
  /* DIE SEITE WAEHLT DER KUNDE (Betreiber 2026-09-29: „اريد ان يختار العميل اين يقوم بوضعه وليس انت — لانه احيانا بعض
     المطابخ فيها اكثر من خزانة طويلة" · „يوجد ايضا خزائن طويلة غير البراد والفرن" · „اريدها بطريقة سهلة للعميل بدون ارباك").
     EINE Stelle, EINE Frage: tippt der Kunde einen Hochschrank an (Kuehlschrank, Backofen, Vorratsschrank — auch die Nische
     des eigenen Kuehlschranks), steht oben „Seite: Links | Rechts", wie in der Raumansicht. Die Kueche wird dazu neu geplant
     (K.startKueche mit dem Wunsch `lage`); jeder andere Hochschrank behaelt seine Seite, mehrere auf einer Seite stehen
     nebeneinander. Passen Kuehlschrank und Backofen so nicht, tauschen sie den Platz, und der Kunde liest es; geht auch das
     nicht, bleibt die Kueche. „Rückgängig" holt die vorige zurueck. */
  var lageMeldung = '';
  var LAGE_NAME = { kuehl: 'Der Kühlschrank', ofen: 'Der Backofen-Hochschrank', hoch: 'Der Hochschrank' };
  function lageSuchen(e, inv) {
    return inv.filter(function (q) { return e.stell != null ? String(q.stell) === String(e.stell) : (q.wand === e.wand && q.i === e.i); })[0] || null;
  }
  function lageChips(e) {
    if (!daten || !K.hochInventar) return '';
    var ich = lageSuchen(e, K.hochInventar(z, daten));
    if (!ich || !ich.seite) return '';
    var t = lageMeldung;
    lageMeldung = '';
    var ziel = e.stell != null ? 'stell|' + e.stell : e.wand + '|' + e.i;
    return '<div class="hm-app__chips hm-app__anschlag" role="group" aria-label="Seite"><span class="hm-app__lab">Seite</span>'
      + ['links', 'rechts'].map(function (sd) {
        return '<button type="button" class="hm-app__chip" data-lage="' + ziel + '|' + sd + '" aria-pressed="' + (ich.seite === sd) + '">'
          + (sd === 'links' ? 'Links' : 'Rechts') + '</button>';
      }).join('') + '</div>'
      + (t ? '<p class="hm-app__klein" role="status">' + esc(t) + '</p>'
        : (istStartPlan() ? '' : '<p class="hm-app__klein">Die Küche wird dafür neu geplant – Ihre Änderungen holt „Rückgängig“ zurück.</p>'));
  }
  function lageBinden(box) {
    box.querySelectorAll('[data-lage]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-lage').split('|');
        lageWaehlen(t[0] === 'stell' ? { stell: t[1] } : { wand: t[0], i: +t[1] }, t[2]);
      });
    });
  }
  function lageWaehlen(e, sd) {
    if (!daten) return;
    var inv = K.hochInventar(z, daten), ich = lageSuchen(e, inv);
    if (!ich || ich.seite === sd) return;
    /* Die Seiten, wie sie jetzt sind — nur die angetippte aendert sich. */
    var jetzt = function () {
      var l = { extra: [] };
      inv.forEach(function (q) {
        if ((q.typ === 'kuehl' || q.typ === 'ofen') && !l[q.typ]) l[q.typ] = q.seite;
        else if (q.typ === 'hoch') l.extra.push({ mi: q.mi, wahl: q.wahl, seite: q.seite, du: q === ich });
      });
      return l;
    };
    var lage = jetzt();
    if (ich.typ === 'hoch') lage.extra.forEach(function (x) { if (x.du) x.seite = sd; });
    else lage[ich.typ] = sd;
    var sauber = function (l) {
      var o = {};
      if (l.kuehl) o.kuehl = l.kuehl;
      if (l.ofen) o.ofen = l.ofen;
      if (l.extra.length) o.extra = l.extra.map(function (x) { return { mi: x.mi, wahl: x.wahl, seite: x.seite }; });
      return o;
    };
    /* Erst rechnen, dann umbauen. Die Nischen eigener Geraete baut der Kern neu (wie beim Betreten der Kueche, geheZu). */
    var nischen = stellplaetze();
    var versuch = function (l) {
      var probe = {};
      for (var k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) probe[k] = z[k]; }
      probe.wunsch = wunschFertig(); probe.wunsch.lage = sauber(l);
      probe.plan = {}; probe.hoff = {}; probe.xpos = {}; probe.wahl = {};
      probe.merkmale = (z.merkmale || []).filter(function (m) { return nischen.indexOf(m) < 0; });
      var r = K.startKueche(probe, daten);
      return r && !r.lageFehlt ? r : null;
    };
    var r = versuch(lage), tausch = null;
    var anderer = ich.typ === 'kuehl' ? 'ofen' : (ich.typ === 'ofen' ? 'kuehl' : null);
    if (!r && anderer && lage[anderer] === sd) {
      var lage2 = jetzt();
      lage2[ich.typ] = sd; lage2[anderer] = ich.seite;
      r = versuch(lage2);
      if (r) { lage = lage2; tausch = anderer; }
    }
    if (!r) {
      lageMeldung = (sd === 'links' ? 'Links' : 'Rechts') + ' ist dafür zu wenig Platz – Spüle, Kochfeld und Geschirrspüler gehen vor.';
      sagen(lageMeldung);
      blattZeigen();
      return;
    }
    vorherSchreiben(K.planNutzlast(z, daten));
    (z.wunsch = z.wunsch || {}).lage = sauber(lage);
    z.plan = {}; z.hoff = {}; z.xpos = {}; z.wahl = {}; z.sel = null;
    startMarke(false);
    geheZu('kueche', 'ersetzen');
    /* Der verstellte Schrank bleibt gewaehlt — der Kunde sieht ihn an seiner neuen Stelle, darunter, was geschehen ist. */
    var text = LAGE_NAME[ich.typ] + ' steht jetzt ' + sd + (tausch ? ' – ' + LAGE_NAME[tausch].replace(/^Der /, 'der ') + ' hat dafür den Platz getauscht.' : '.');
    var neu = K.hochInventar(z, daten).filter(function (q) {
      return q.typ === ich.typ && q.seite === sd && (ich.typ !== 'hoch' || q.mi === ich.mi);
    })[0];
    lageMeldung = text;
    if (neu) {
      z.wand = neu.wand; z.sel = neu.stell != null ? 'stell|' + neu.stell : neu.wand + '|boden|' + neu.i;
      blattModus = 'auswahl';
      kuecheZeigen();
    } else lageMeldung = '';
    sagen(text);
  }
  function pdfKnoepfeBinden(box) {
    box.querySelectorAll('[data-pdf]').forEach(function (b) {
      b.addEventListener('click', function () { pdfLaden(b.getAttribute('data-pdf') === '1', b); });
    });
  }
  function pdfLaden(ohnePreise, knopf) {
    if (pdfLaeuft || !w.HMPlanerPdf || !w.HMPlanerBeleg || !daten) return;
    pdfLaeuft = true;
    var span = knopf && knopf.querySelector('span'), alt = span ? span.textContent : '';
    var zeige = function (t) { if (span) span.textContent = t; };
    var namen = {}; namen[z.form] = raumText()[0];
    var html = w.HMPlanerBeleg.html(z, daten, belegCfg(), ohnePreise, namen);
    var datum = new Date(), zwei = function (n) { return (n < 10 ? '0' : '') + n; };
    var name = 'Hi-Markt-Kuechenplanung-' + String(z.serie || 'Kueche').replace(/[^A-Za-z0-9]+/g, '-')
      + (ohnePreise ? '-ohne-Preise' : '') + '-' + datum.getFullYear() + '-' + zwei(datum.getMonth() + 1) + '-' + zwei(datum.getDate()) + '.pdf';
    if (knopf) knopf.disabled = true;
    zeige('PDF wird erstellt …');
    w.HMPlanerPdf.herunterladen(html, name, function (a) { zeige('PDF wird erstellt … ' + Math.round(a * 100) + ' %'); })
      .then(function () { sagen('PDF gespeichert: ' + name); })
      .catch(function (e) {
        if (w.console && w.console.warn) w.console.warn('[kuechenplaner] PDF', e);
        sagen('Das PDF ließ sich auf diesem Gerät nicht erstellen – „Ansehen & drucken" in der Zusammenfassung geht immer.');
      })
      .then(function () { pdfLaeuft = false; if (knopf) knopf.disabled = false; zeige(alt); });
  }

  /* ---------- Zusammenfassung ---------- */

  var zusammenVon = null;
  function zusammenfassungOeffnen() {
    var d = $('[data-app-zusammen]'), inhalt = $('[data-app-zusammeninhalt]');
    if (!d || !daten) return;
    var pos = K.positionen(z, daten), rb = rabattRechnung();
    var nicht = String(CFG.lieferhinweis || '').split(/\n+/).map(function (x) { return x.trim(); }).filter(Boolean);
    if (K.inselOhnePlatte(z)) nicht.push(K.INSEL_OHNE_PLATTE);
    /* Der eigene Geschirrspueler steht in keiner Zeile — also hier, beim Namen. */
    var nGs = stellplaetze().filter(function (m) { return m.typ !== 'kuehl'; });
    var nKs = stellplaetze().filter(function (m) { return m.typ === 'kuehl'; });
    if (nKs.length) {
      nicht.unshift('Eigener Kühlschrank: eingeplant ist nur die Nische (' + nKs.map(function (m) { return K.r0(m.breite) + ' cm'; }).join(', ')
        + ') ohne Schrank – Gerät und Anschluss sind nicht enthalten.');
    }
    if (nGs.length) {
      nicht.unshift('Eigener Geschirrspüler: eingeplant ist nur die Nische (' + nGs.map(function (m) { return K.r0(m.breite) + ' cm'; }).join(', ')
        + ') ohne Front – Gerät, Anschluss und Montage sind nicht enthalten.');
    }
    inhalt.innerHTML = '<p class="hm-app__klein">' + esc(z.serie + ' · ' + z.farbe + ' · ' + raumText().join(' · ')) + '</p>'
      + '<ul class="hm-app__liste">' + pos.map(function (p) {
        return '<li><span>' + esc(p.menge + ' × ' + kurzName(p.m)) + ' <small>' + esc(breiteText(p.m) + (p.wahl ? ' · ' + p.wahl : '')) + '</small></span>'
          + '<span>' + esc(K.eur(p.menge * p.v.preis)) + '</span></li>';
      }).join('') + K.zubehoerPos(z, daten).map(function (a) {
        return '<li><span>' + esc(a.menge + ' × ' + a.name) + '</span><span>' + esc(K.eur(a.betrag)) + '</span></li>';
      }).join('') + K.arbeitsplattenPos(z, daten).map(function (a) {
        /* Die Summe enthielt die Platten schon, die Liste nicht. */
        return '<li><span>1 × Arbeitsplatte ' + esc(a.name) + ' <small>' + esc(a.laenge + ' cm · ' + wandName(a.wand)) + '</small></span><span>' + esc(K.eur(a.betrag)) + '</span></li>';
      }).join('') + '<li class="hm-app__summenzeile"><span>Summe</span><span>' + esc(K.eur(K.gesamt(z, daten))) + '</span></li>'
      /* Ab der Grenze: der Planungsrabatt als Zeile und der Preis danach — dieselben Zahlen wie unten in der Leiste. */
      + (rb && rb.erreicht ? '<li class="hm-app__rabattzeile"><span>' + rb.prozent + ' % Planungsrabatt</span><span>−' + esc(K.eur(rb.nachlass)) + '</span></li>'
        + '<li class="hm-app__summenzeile"><span>Ihr Preis</span><span>' + esc(K.eur(rb.preis)) + '</span></li>' : '') + '</ul>'
      + (rb ? '<p class="hm-app__klein">' + esc(rb.erreicht ? rabattBedingung(rb) : rabattZeile(rb)) + '</p>' : '')
      + (nicht.length ? '<h3 class="hm-app__h3">Nicht in der Summe</h3><ul class="hm-app__punkte">' + nicht.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '')
      + (CFG.vorbehalt ? '<p class="hm-app__klein">' + esc(CFG.vorbehalt) + '</p>' : '')
      + '<div class="hm-app__belege" data-app-belege></div>';
    if (w.HMPlanerBeleg) {
      var bb = $('[data-app-belege]');
      bb.innerHTML = (w.HMPlanerPdf ? pdfKnopf('0', 'Planung als PDF') + pdfKnopf('1', 'PDF ohne Preise') : '')
        + '<button type="button" class="hm-app__chip" data-beleg="0">Ansehen &amp; drucken</button>';
      bb.classList.add('hm-app__pdfzeile');
      pdfKnoepfeBinden(bb);
      bb.querySelectorAll('[data-beleg]').forEach(function (b) {
        b.addEventListener('click', function () { belegOeffnen(b.getAttribute('data-beleg') === '1'); });
      });
    }
    zusammenVon = doc.activeElement;
    d.hidden = false;
    var zu = d.querySelector('[data-app-zusammenzu]');
    if (zu) zu.focus();
  }
  function zusammenfassungSchliessen() {
    var d = $('[data-app-zusammen]');
    if (!d || d.hidden) return;
    d.hidden = true;
    if (zusammenVon && zusammenVon.focus) zusammenVon.focus();
  }
  /* Das Deckblatt des Belegs zeigt die Kueche in 3D — so, wie der Kunde sie gerade sieht. Nur wenn
     die 3D-Ansicht steht; sonst traegt das Deckblatt den Grundriss (hm-planer-beleg.js). CFG selbst
     bleibt unberuehrt: das Bild gilt fuer genau diesen einen Beleg. */
  function belegCfg() {
    var c = {}, k;
    for (k in CFG) { if (Object.prototype.hasOwnProperty.call(CFG, k)) c[k] = CFG[k]; }
    c.bild3d = null;
    /* Der Planungsrabatt fuer die PDF: dieselben Zahlen wie in der Leiste (rabattRechnung). */
    var rb = rabattRechnung();
    c.rabatt = rb && rb.erreicht ? { prozent: rb.prozent, nachlass: K.eur(rb.nachlass), preis: K.eur(rb.preis) } : null;
    if (ansichtDrei && dreiGebaut && w.HMKonfig3D && w.HMKonfig3D.bereit()
      && typeof w.HMKonfig3D.schnappschuss === 'function') {
      try { c.bild3d = w.HMKonfig3D.schnappschuss(1600); } catch (e) { c.bild3d = null; }
    }
    return c;
  }
  function belegOeffnen(ohnePreise) {
    var namen = {}; namen[z.form] = raumText()[0];
    var html = w.HMPlanerBeleg.html(z, daten, belegCfg(), ohnePreise, namen);
    var f = $('[data-app-belegrahmen]'), k = $('[data-app-beleg]');
    if (!f || !k) return;
    f.setAttribute('srcdoc', html);
    k.hidden = false;
  }

  function fussZeigen() {
    var def = SCHIRME[schirmNr(schirm)];
    var weiter = $('[data-app-weiter]'), summe = $('[data-app-summe]');
    weiter.textContent = def.weiter;
    var naechster = SCHIRME[schirmNr(schirm) + 1];
    var fehlzeile = $('[data-app-fehlzeile]');
    fehlzeile.hidden = true;
    weiter.removeAttribute('aria-busy');
    if (naechster) {
      weiter.disabled = !erreichbar(naechster.id, z, daten) || !!laedt;
    } else {
      /* Die Kasse: frei, wenn der Kern den Plan kaufbar nennt. Sonst nennt der Knopf den
         Grund, und der erste offene Punkt steht als rote Zeile darueber (PLAN §2). */
      var offen = daten ? offenePunkte() : [];
      /* Die Sockelleiste zaehlt als offener Punkt, bis der Kunde sie hinzufuegt (Pflicht, siehe sockelFehlt). */
      var ohneSockel = daten && K.anzahl(z, daten) ? sockelFehlt() : false;
      var nOffen = offen.length + (ohneSockel ? 1 : 0);
      var kaufbar = !!daten && K.kaufbar(z, daten) && !ohneSockel;
      weiter.disabled = !kaufbar || kaufLaeuft;
      if (kaufLaeuft) { weiter.textContent = 'Kasse wird vorbereitet …'; weiter.setAttribute('aria-busy', 'true'); }
      else if (!daten || !K.anzahl(z, daten)) weiter.textContent = 'Erst Schränke setzen';
      else if (nOffen) weiter.textContent = nOffen === 1 ? '1 Punkt offen' : nOffen + ' Punkte offen';
      var zeile = kaufMeldung || (offen.length ? kundenText(offen[0].text) : (ohneSockel ? SOCKEL_FEHLT : ''));
      if (zeile) { fehlzeile.textContent = zeile; fehlzeile.hidden = false; }
    }
    if (schirm === 'kueche' && daten && K.anzahl(z, daten)) {
      /* Die Summe ist ein Knopf: sie oeffnet die Zusammenfassung. Ab der Grenze steht der Preis NACH dem
         Planungsrabatt da, darunter der Rabatt als Betrag (siehe rabattRechnung). */
      var rb = rabattRechnung();
      summe.innerHTML = '<button type="button" class="hm-app__summenknopf" data-app-summeauf aria-haspopup="dialog">'
        + '<span class="hm-app__betrag">' + esc(K.eur(rb && rb.erreicht ? rb.preis : K.gesamt(z, daten))) + '</span>'
        + '<span class="hm-app__zeile' + (rb && rb.erreicht ? ' hm-app__zeile--rabatt' : '') + '" data-app-rabatt>'
        + esc(rabattZeile(rb) || (K.anzahl(z, daten) + ' Schränke')) + '</span></button>';
      summe.querySelector('[data-app-summeauf]').addEventListener('click', zusammenfassungOeffnen);
    } else if (schirm === 'stil' && daten && daten.serie === z.serie && z.farbe) {
      /* Serie und Farbe — der Preis steht erst in der Kueche, mit dem Planungsrabatt (siehe stilPreiseZeigen). */
      summe.innerHTML = '<span class="hm-app__betrag">' + esc(z.serie) + '</span>'
        + '<span class="hm-app__zeile">' + esc(z.farbe) + '</span>';
    } else if (schirm === 'stil' && !laedt && !(daten && daten.serie === z.serie && z.farbe)) {
      /* Sonst stand „Küche ansehen" grau da, ohne dass der Kunde erfuhr, warum. */
      summe.innerHTML = '<span class="hm-app__zeile hm-app__zeile--raum">' + (z.serie ? 'Farbe wählen' : 'Serie wählen') + '</span>'
        + '<span class="hm-app__zeile">danach ist Ihre Küche fertig geplant</span>';
    } else if (schirm === 'raum') {
      var rt = raumText();
      summe.innerHTML = '<span class="hm-app__zeile hm-app__zeile--raum">' + esc(rt[0]) + '</span><span class="hm-app__zeile">' + esc(rt[1]) + '</span>';
    } else {
      summe.innerHTML = '';
    }
  }

  /* ---------- Ausstattung (Betreiber 2026-09-26) ----------

     Vier einfache Fragen, bevor die Kueche gebaut wird: „damit das System weiss, wie es baut". Jede
     hat eine fertige Antwort — so, wie der Planer bisher baute —, und „Weiter" geht auch ohne Wahl.
     Die Arbeitsplatte ist Ware: dort steht „Später entscheiden" vorn, nie „Ja" (§ 312a Abs. 3 BGB).
     Eine geaenderte Antwort plant die Kueche neu, mit Rueckweg zur vorigen — wie nach neuen Massen. */
  var FRAGEN = [
    { k: 'gs', t: 'Geschirrspüler', a: [
      ['voll', 'Vollintegriert', 'Die Möbelfront deckt das Gerät ganz ab.'],
      ['teil', 'Teilintegriert', 'Die Bedienblende des Geräts bleibt sichtbar, darunter eine halbe Front.'],
      ['eigen', 'Eigenes Gerät', 'Ihr Geschirrspüler mit eigener Tür: wir lassen eine 60-cm-Nische frei – ohne Front.'],
      ['keiner', 'Kein Geschirrspüler', 'An seiner Stelle planen wir einen Unterschrank.']] },
    /* Betreiber 2026-09-26 nach dem Vergleich mit ROYAL24: deren Startkueche hat einen Kuehlschrank,
       unsere hatte nie einen. Standard ist der Einbau — wie beim Geschirrspueler die Front. */
    { k: 'kuehl', t: 'Kühlschrank', a: [
      ['einbau', 'Im Hochschrank', 'Ein Einbau-Kühlschrank hinter einer Möbelfront – am Ende der Küche, weg vom Herd.'],
      ['eigen', 'Freistehend (eigenes Gerät)', 'Wir lassen eine 60-cm-Nische frei – für Ihren freistehenden Kühlschrank.'],
      ['keiner', 'Nicht in der Küche', 'Wir planen keinen Platz für den Kühlschrank in der Küche.']] },
    /* Farbe des eigenen Kuehlschranks (Betreiber 2026-09-27: „والبراد يمكن ان يكون ابيض او اسود او رمادي") — nur bei
       „Freistehend" gefragt und nur fuer die Ansicht: das Geraet bringt der Kunde mit, die Kueche aendert sich nicht. */
    { k: 'kuehlFarbe', t: 'Farbe des Kühlschranks', nur: ['kuehl', 'eigen'], a: [
      ['weiss', 'Weiß', 'So zeigen wir Ihren Kühlschrank in der Ansicht.'],
      ['schwarz', 'Schwarz', 'So zeigen wir Ihren Kühlschrank in der Ansicht.'],
      ['grau', 'Grau', 'So zeigen wir Ihren Kühlschrank in der Ansicht – in Edelstahl-Optik.']] },
    { k: 'ofen', t: 'Backofen', a: [
      /* Namen (Betreiber 2026-09-26): „Im Hochschrank" / „Unter dem Kochfeld" statt „In Augenhöhe" /
         „Unter der Arbeitsplatte" — sie sagen, WO der Ofen steht, wie beim Kuehlschrank. */
      ['hoch', 'Im Hochschrank', 'Ohne Bücken: der Backofen sitzt im Hochschrank auf Brusthöhe – wo Serie und Raumhöhe es erlauben.'],
      ['unten', 'Unter dem Kochfeld', 'Klassisch, wie in den meisten Küchen: der Backofen im Unterschrank unter dem Kochfeld.']] },
    { k: 'oben', t: 'Hängeschränke', a: [
      ['ja', 'Ja', 'Hängeschränke über der Arbeitsplatte.'],
      ['nein', 'Nein', 'Die Wand über der Arbeitsplatte bleibt frei.']] },
    { k: 'platte', t: 'Arbeitsplatte', a: [
      ['spaeter', 'Später entscheiden', 'Sie wählen sie bei Ihrer Küche – oder gar nicht.'],
      ['ja', 'Ja, aus dem Shop', 'Auf Ihre Maße zugeschnitten. Das Dekor ändern Sie bei Ihrer Küche.'],
      ['nein', 'Nein, habe ich schon', 'Wir planen nur die Schränke.']] }
  ];
  var platteOffen = false;
  function wunschVon(k) {
    var q = FRAGEN.filter(function (x) { return x.k === k; })[0], v = (z.wunsch || {})[k];
    return q.a.some(function (a) { return a[0] === v; }) ? v : q.a[0][0];
  }
  /* Die Antworten, wie der Kunde sie SIEHT — jede Frage mit ihrem Wert, unbeantwortete mit dem Standard.
     Der Kern liest einen fehlenden Wert als „wie bisher"; beim Kuehlschrank ist das „keiner", der
     Standard hier aber „im Hochschrank". Deshalb bekommt der Kern immer diese vollstaendige Fassung. */
  function wunschFertig() {
    var o = {};
    (FRAGEN || []).forEach(function (q) { o[q.k] = wunschVon(q.k); });
    /* Dazu die Seite, die der Kunde fuer Kuehlschrank und Backofen-Hochschrank gewaehlt hat (lageWaehlen) — keine Frage
       der Ausstattung, er waehlt sie an seiner Kueche. */
    var lg = (z.wunsch || {}).lage;
    if (lg && (lg.kuehl || lg.ofen)) { o.lage = {}; if (lg.kuehl) o.lage.kuehl = lg.kuehl; if (lg.ofen) o.lage.ofen = lg.ofen; }
    return o;
  }
  /* PLANUNGS-CHECK (2026-09-26, nach dem Vergleich mit ROYAL24): die Faustregeln der Kuechenplanung als
     Punkte aus dem Kern (K.planungsCheck). Aufgeklappt, sobald ein Punkt nicht erfuellt ist. */
  function checkKarte() {
    if (!daten || !K.planungsCheck || !K.anzahl(z, daten)) return '';
    var c = K.planungsCheck(z, daten), offen = offeneTexte();
    if (!c.length && !offen.length) return '';
    /* Die offenen Punkte der Kasse zaehlen mit und stehen oben — nie „alle erfüllt", solange die Kasse gesperrt ist. */
    var ok = c.filter(function (x) { return x.ok; }).length, n = c.length + offen.length;
    return '<details class="hm-app__check"' + (ok < n ? ' open' : '') + '><summary><b>Planungs-Check</b><span>'
      + ok + ' von ' + n + ' Punkten erfüllt</span></summary><ul>' + offen.map(function (t) {
        return '<li class="hin" data-offen><b>Vor der Bestellung ändern</b><span>' + esc(t) + '</span></li>';
      }).join('') + c.map(function (x) {
        return '<li class="' + (x.ok ? 'ok' : 'hin') + '"><b>' + esc(x.titel) + '</b><span>' + esc(x.text) + '</span>'
          + (x.aktion === 'ofen-unten' ? '<button type="button" class="hm-app__chip hm-app__checkknopf" data-check-aktion="ofen-unten">'
            + 'Backofen unter das Kochfeld</button>' : '') + '</li>';
      }).join('') + '</ul></details>';
  }
  /* Kuehlschrank gewuenscht, aber nicht in der Kueche: sagen, warum. Abgelesen an Plan und Raum, nicht
     an einem gespeicherten Merker — so stimmt es auch nach dem Neuladen und nach eigenen Aenderungen. */
  function kuehlHinweis() {
    var wk = daten ? wunschVon('kuehl') : 'keiner';
    if (wk === 'keiner' || !K.anzahl(z, daten)) return '';
    /* Der Kunde kann in der Kueche selbst gewechselt haben (Hochschrank ↔ Nische): beides zaehlt. */
    var da = stellplaetze().some(function (m) { return m.typ === 'kuehl'; }) || K.waende(z).some(function (wd) {
      return K.items(z, daten, wd.id, 'boden').some(function (it) { return it.m.funktion === 'kuehlumbau'; });
    });
    if (da) return '';
    if (wk === 'eigen') {
      return '<p class="hm-app__hinweis" role="note">Für die Nische Ihres eigenen Kühlschranks reicht die Wand nicht: '
        + 'Spüle, Kochfeld und Geschirrspüler gehen vor.</p>';
    }
    var kat = (daten.modelle || []).filter(function (m) { return m.funktion === 'kuehlumbau' && K.variante(m, z.farbe, z.zusatz); });
    var hh = K.geo(daten).hochschrank_hoehe, t;
    if (!kat.length) t = 'Diese Serie führt in dieser Farbe keinen Kühlumbauschrank. Wählen Sie „Freistehend (eigenes Gerät)“ – dann lassen wir eine Nische frei.';
    else if ((+z.hoehe || 250) < hh + 4) {
      t = 'Der Kühlumbauschrank dieser Serie ist ' + hh + ' cm hoch – bei ' + (+z.hoehe || 250)
        + ' cm Raumhöhe passt er nicht. Ab ' + (hh + 4) + ' cm Raumhöhe planen wir ihn ein – oder wählen Sie „Freistehend (eigenes Gerät)“.';
    } else t = 'Für den Kühlumbauschrank reicht die Wand nicht: Spüle, Kochfeld und Geschirrspüler gehen vor.';
    return '<p class="hm-app__hinweis" role="note">' + esc(t) + '</p>';
  }
  /* Stufe 2: Geschirrspueler gewuenscht, aber nicht in der Kueche — der Wasseranschluss liegt an einer kurzen Wand, und an
     der Nachbarwand stand kein Schrank seiner Breite, an dessen Stelle er haette treten koennen (K.startKueche). */
  function gsHinweis() {
    var wg = daten ? wunschVon('gs') : 'keiner';
    if (wg === 'keiner' || !K.anzahl(z, daten)) return '';
    var da = stellplaetze().some(function (m) { return m.typ === 'spueler'; }) || K.waende(z).some(function (wd) {
      return K.items(z, daten, wd.id, 'boden').some(function (it) { return it.m.funktion === 'geschirrspuelerfront'; });
    });
    if (da) return '';
    return '<p class="hm-app__hinweis" role="note">Für den Geschirrspüler war neben dem Spülenschrank kein Platz. Über „Schrank hinzufügen“ '
      + 'lässt sich eine Geschirrspülerfront an anderer Stelle einplanen.</p>';
  }
  function ausstattungZeigen() {
    var box = $('[data-app-ausstattung]');
    if (!box) return;
    box.innerHTML = '<p class="hm-app__klein hm-app__fragetext">Danach planen wir Ihre Küche. Sie können alles später noch ändern.</p>'
      + FRAGEN.filter(function (q) { return !q.nur || wunschVon(q.nur[0]) === q.nur[1]; }).map(function (q) {
        var jetzt = wunschVon(q.k), hin = q.a.filter(function (a) { return a[0] === jetzt; })[0];
        return '<div class="hm-app__frage" role="group" aria-labelledby="hm-frage-' + q.k + '"><b id="hm-frage-' + q.k + '">' + esc(q.t) + '</b>'
          + '<div class="hm-app__chips">' + q.a.map(function (a) {
            return '<button type="button" class="hm-app__chip" data-wunsch="' + q.k + '" data-wert="' + a[0] + '" aria-pressed="'
              + (a[0] === jetzt) + '">' + esc(a[1]) + '</button>';
          }).join('') + '</div><p class="hm-app__klein">' + esc(hin[2]) + '</p></div>';
      }).join('');
    box.querySelectorAll('[data-wunsch]').forEach(function (b) {
      b.addEventListener('click', function () { wunschSetzen(b.getAttribute('data-wunsch'), b.getAttribute('data-wert')); });
    });
  }
  function wunschSetzen(k, v) {
    if (wunschVon(k) === v) return;
    z.wunsch = z.wunsch || {};
    z.wunsch[k] = v;
    /* Geschirrspueler, Backofen und Haengeschraenke bestimmen den Bau: die Kueche wird neu geplant (eine
       veraenderte vorher gesichert). Die Arbeitsplatte nicht — sie wird beim Betreten der Kueche gesetzt
       oder entfernt, nur dieses eine Mal: eine spaetere Wahl bei der Kueche bleibt dann unberuehrt. */
    /* Die Farbe des eigenen Kuehlschranks aendert nur die Ansicht — keine neue Kueche. */
    if (k === 'platte') platteOffen = true; else if (k !== 'kuehlFarbe') raumNeu();
    merken();
    ausstattungZeigen();
  }
  /* „Ja, aus dem Shop": ein neutrales Dekor, bis der Kunde bei seiner Kueche ein anderes waehlt.
     „Nein": keine Platte. „Später": nichts anfassen. */
  function platteNachWunsch() {
    var wa = (z.wunsch || {}).platte;
    if (wa === 'nein') { z.platte = null; return; }
    if (wa !== 'ja' || z.platte || !daten) return;
    var tab = K.plattenTabelle(daten) || [];
    var p = tab.filter(function (x) { return x.id === 'marmor-bianco-13'; })[0] || tab[0];
    z.platte = p ? p.id : null;
  }

  function zeigen() {
    wurzel.setAttribute('data-schirm', schirm);
    var nr = schirmNr(schirm);
    $('[data-app-nr]').textContent = (nr + 1) + '/' + SCHIRME.length;
    $('[data-app-name]').textContent = SCHIRME[nr].name;
    $('[data-app-zurueck]').hidden = nr === 0;
    $$('[data-app-schirm]').forEach(function (s) { s.hidden = s.getAttribute('data-app-schirm') !== schirm; });
    if (schirm === 'raum') raumZeigen();
    if (schirm === 'ausstattung') ausstattungZeigen();
    if (schirm === 'stil') stilZeigen();
    if (schirm === 'kueche') kuecheZeigen();
    fussZeigen();
  }

  /* ---------- Knoepfe im Rahmen ---------- */


  $('[data-app-weiter]').addEventListener('click', function () {
    var naechster = SCHIRME[schirmNr(schirm) + 1];
    if (naechster) geheZu(naechster.id, 'push');
    else zurKasse();
  });
  /* Zusammenfassung und Beleg: schliessen per Knopf, Escape und Tipp auf den Hintergrund. */
  wurzel.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-app-zusammenzu]') || t.matches('[data-app-zusammen]')) zusammenfassungSchliessen();
    if (t.closest('[data-app-belegzu]')) { var k = $('[data-app-beleg]'); if (k) k.hidden = true; }
    if (t.closest('[data-app-belegdruck]')) { var f = $('[data-app-belegrahmen]'); if (f && f.contentWindow) f.contentWindow.print(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (neuSchliessen()) return;
    var k = $('[data-app-beleg]');
    if (k && !k.hidden) { k.hidden = true; return; }
    zusammenfassungSchliessen();
  });
  /* Zurueck = ein Schritt in der Geschichte, solange die App sie selbst gelegt hat; sonst (nach
     einem Neuladen) der vorige Bildschirm ohne neuen Eintrag. */
  $('[data-app-zurueck]').addEventListener('click', function () {
    var vor = SCHIRME[schirmNr(schirm) - 1];
    if (!vor) return;
    if (tiefe > 0) w.history.back();
    else geheZu(vor.id, 'ersetzen');
  });

  /* ---------- Neue Planung ----------

     Betreiber 2026-09-28: „لايوجد زر لاعادة فتح من البداية". Der alte Planer hatte „Neue Planung" im Kopf, die App
     keinen Weg zurueck an den Anfang — wer neu beginnen wollte, musste jede Wand einzeln leeren. Der Knopf steht im
     Kopf JEDES Bildschirms; gefragt wird vorher, denn geloescht ist geloescht.
     Geloescht wird, was diese Planung ausmacht: der Plan (K.verwerfen, auch der Schluessel der Vorversion), die Marke
     der Startkueche und ihr Fingerabdruck, die gesicherte vorherige Kueche und die Wahl zur Sockelleiste. Die Wahl
     2D/3D bleibt — sie gehoert zum Geraet, nicht zur Kueche. Danach laedt die Seite OHNE Anker neu: ein neuer Besuch
     beginnt bei „Raum & Maße" (siehe Start), und nichts aus der alten Planung haengt mehr im Speicher der Seite
     (Rueckgaengig-Stapel, 3D-Szene, geladener Katalog). */
  var neuDialog = $('[data-app-neudialog]'), neuVorher = null;
  function neuOeffnen() {
    neuVorher = doc.activeElement;
    neuDialog.hidden = false;
    /* Der Fokus auf „Abbrechen": wer nur Enter drueckt, verliert nichts. */
    neuDialog.querySelector('[data-app-neunein]').focus({ preventScroll: true });
  }
  function neuSchliessen() {
    if (!neuDialog || neuDialog.hidden) return false;
    neuDialog.hidden = true;
    if (neuVorher && neuVorher.focus) neuVorher.focus({ preventScroll: true });
    neuVorher = null;
    return true;
  }
  function neuePlanung() {
    verworfen = true;
    K.verwerfen();
    startMarke(false);
    [START_PLAN, VORHER, SOCKEL_MARKE].forEach(function (k) {
      try { w.localStorage.removeItem(k); } catch (e) { /* ohne Speicher gibt es nichts zu loeschen */ }
    });
    w.location.replace(w.location.pathname + w.location.search);
  }
  /* Ohne Markup (ein aelterer Abschnitt neben neuerem Skript) bleibt es beim Planer ohne Knopf — nie ohne Planer. */
  if (neuDialog && $('[data-app-neu]')) {
    $('[data-app-neu]').addEventListener('click', neuOeffnen);
    /* Tipp daneben oder „Abbrechen" schliesst, „Neu beginnen" loescht. */
    neuDialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-app-neuja]')) neuePlanung();
      else if (e.target === neuDialog || e.target.closest('[data-app-neunein]')) neuSchliessen();
    });
  }

  /* Drehen oder Fensterbreite: die Zeichnungen haengen an der gemessenen Groesse. */
  var groesseZeit = null;
  w.addEventListener('resize', function () {
    w.clearTimeout(groesseZeit);
    groesseZeit = w.setTimeout(function () {
      if (schirm === 'raum') grundrissZeigen();
      if (schirm === 'kueche' && daten) zeichnungZeigen();
    }, 150);
  });

  /* ---------- Bildschirmtastatur ----------
     iOS verkleinert 100dvh nicht, wenn die Tastatur aufgeht — die Fussleiste laege dahinter und
     das Feld darunter. visualViewport kennt die wirklich sichtbare Hoehe. */
  if (w.visualViewport) {
    var vv = w.visualViewport;
    var anpassen = function () {
      var offen = vv.height < w.innerHeight - 80;
      if (offen) wurzel.style.setProperty('--hm-app-vh', Math.round(vv.height) + 'px');
      else wurzel.style.removeProperty('--hm-app-vh');
      var aktiv = doc.activeElement;
      if (offen && aktiv && wurzel.contains(aktiv) && /^(INPUT|SELECT|TEXTAREA)$/.test(aktiv.tagName)) {
        aktiv.scrollIntoView({ block: 'center' });
      }
    };
    vv.addEventListener('resize', anpassen);
  }

  /* ---------- Start ---------- */

  /* EIN NEUER BESUCH BEGINNT BEI „RAUM & MASSE" (Betreiber 2026-09-28: „عند الدخول الى القسم يجب ان يكون العميل في
     الصفحة الاولى"). Bis hierher sprang die App an den gespeicherten Bildschirm: wer einmal bis zur Kueche geplant hatte,
     landete bei jedem neuen Aufruf — Menue, Startseite, Lesezeichen — mitten in „Ihre Küche". Die Planung selbst bleibt
     gespeichert: Masse, Antworten, Serie und Schraenke stehen wieder da, und „Weiter" fuehrt zu derselben Kueche zurueck.
     KEIN neuer Besuch sind Neuladen und Zurueck/Vor (etwa aus der Kasse): dann gilt wie bisher der Anker der Adresse
     (#kueche), sonst der Stand aus dem Speicher. */
  function neuerBesuch() {
    try {
      var nav = w.performance && w.performance.getEntriesByType ? w.performance.getEntriesByType('navigation')[0] : null;
      if (nav && nav.type) return nav.type !== 'reload' && nav.type !== 'back_forward';
      var alt = w.performance && w.performance.navigation;
      if (alt) return alt.type !== 1 && alt.type !== 2;
    } catch (e) { /* ohne Auskunft gilt: neuer Besuch */ }
    return true;
  }
  /* Ein Sprungziel in der Adresse (#stil) gilt nur, wenn es erlaubt ist — sonst der Stand aus
     dem Speicher. */
  var hash = String(w.location.hash || '').replace('#', '');
  if (neuerBesuch()) schirm = 'raum';
  else if (schirmNr(hash) > -1) schirm = hash;
  /* Steht der Kunde auf der Kueche, wartet sie auf ihren Katalog: bis dahin zeigt der
     Bildschirm „wird geladen", danach entscheidet `geheZu`, ob sie wirklich erreichbar ist.
     Vorher kurz den Stil zu zeigen und dann zu springen, waere ein Flackern ohne Grund. */
  if (z.serie) {
    if (schirm === 'kueche') wartetAuf = 'kueche';
    serieLaden(z.serie);
  }
  if (wartetAuf) zeigen();
  else geheZu(schirm, 'start');
  /* Die Kataloge fuer die Stilkarten schon im Hintergrund holen, wenn der Browser Luft hat. */
  (w.requestIdleCallback || function (f) { return w.setTimeout(f, 1200); })(alleLaden);
})(window);
